<div class="container flex-column" xmlns="http://www.w3.org/1999/html">
  <div class="d-flex justify-content-end mt-2">
  </div>
  <div class="riplay-title text-center">
    <img src="../../../assets/Logo-eSPAJK-syariah.png" width="357">
  </div>
  <div class="container mt-5 pt-4 form-header bg-white">
    <div class="info-box d-flex p-3 rounded-3" role="alert">
      <i class="bi-info-circle"></i>
      <p class="px-1">Harap unduh Dokumen SPAJPK Syariah dan RIPLAY Personal untuk ditandatangani.</p>
    </div>
  </div>
</div>
<div class="container form-container pb-3 bg-white">
  <div class="master-spajk-riplay px-4">
    <div class="spajk-riplay-wrapper">
      <div class="spajk-wrapper" style="font-family: 'Allianz Neo Light', Geneva, Tahoma, sans-serif;font-size: 14px;"
        #spajkWraper>
        <div class="page-break">
          <table>
            <tr>
              <td>
                <table style="width: 100%;">
                  <tr>
                    <td style="width: 16%; border-right: 3px solid #291b85;">
                      <img
                        src="data:image;base64,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"
                        alt="">
                    </td>
                    <td style="font-size: 20px;padding-left: 10px; color: #291b85; font-weight: bold;">Allianz
                      <br>Syariah </td>
                    <td style="text-align: right;font-size: 20px;font-weight: bold;">PT Asuransi Allianz Life Syariah
                      Indonesia </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table style="width: 100%;">
                  <tr>
                    <td>
                      <span style="font-weight: bold;">SURAT PERMOHONAN ASURANSI JIWA PEMBIAYAAN KUMPULAN (SPAJPK)
                        SYARIAH<br> BISMILLAHIRRAHMAANIRRAHIIM</span><br>
                      <span>HARAP DIISI DENGAN HURUF CETAK</span><br>
                      <span>(sesuai dengan data yang diberikan kepada Bank/Perusahaan Pemberi Fasilitas
                        Pembiayaan)</span>
                    </td>
                    <td style="width: 40%;">
                      <table style="width: 100%;border-collapse: collapse; text-align: left;">
                        <tr>
                          <td style="border: 2px solid black;padding-left: 10px;">NAMA PRODUK</td>
                          <td style="border: 2px solid black;padding-left: 10px;">{{spajkBsi.productName}}</td>
                        </tr>
                        <tr>
                          <td style="border: 2px solid black;padding-left: 10px;">JENIS ASURANSI</td>
                          <td style="border: 2px solid black;padding-left: 10px;">Asuransi Jiwa Pembiayaan Kumpulan</td>
                        </tr>
                        <tr>
                          <td style="border: 2px solid black;padding-left: 10px;">MANFAAT ASURANSI</td>
                          <td style="border: 2px solid black;padding-left: 10px;">Meninggal Dunia</td>
                        </tr>
                        <tr>
                          <td style="border: 2px solid black;padding-left: 10px;">JENIS FASILITAS PEMBIAYAAN</td>
                          <td style="border: 2px solid black;padding-left: 10px;">
                            <input class="checkbox-input readonly-checkbox"
                              [checked]="spajkBsi.productcode==='PPR'?true:false" type="checkbox" value="PPR"
                              id="ppr"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 10px;"
                              for="ppr">PPR</label>
                            <input class="checkbox-input readonly-checkbox"
                              [checked]="spajkBsi.productcode==='PPM'?true:false" type="checkbox" value="PPM"
                              id="ppm"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 10px;"
                              for="ppm">PPM</label>
                            <input class="checkbox-input readonly-checkbox"
                              [checked]="spajkBsi.productcode==='SPKTAPBSI'?true:false" type="checkbox" value="PTA"
                              id="pta"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 10px;"
                              for="pta">PTA</label>
                            <input class="checkbox-input readonly-checkbox"
                              [checked]="spajkBsi.productcode==='SPKTAMBSI'?true:false" type="checkbox" value="PMG"
                              id="pmg"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 10px;"
                              for="pmg">PMG</label>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-bottom: 20px;">
                <table style="border-collapse: collapse; width: 100%;border: 2px solid rgb(0, 0, 0);">
                  <tr style="border-bottom: 2px solid black;">
                    <td colspan="2"
                      style="font-size: 16px;padding-left: 10px; font-weight: bold; background-color: lightgray;"> 1.
                      DATA PIHAK YANG DIASURANSIKAN (“PYD”) </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Nama Lengkap (Sesuai ID)</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.namaLengkap}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Nama Alias (Jika Ada)</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.namaAlias}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">No. KTP</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.nik}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Tempat Lahir</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 20%;display: inline-block;">{{spajkBsi.tempatLahir}}</span>
                      <span>Tanggal Lahir:
                        <span
                          style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.tgl}}</span><span>&nbsp;/&nbsp;</span>
                        <span
                          style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.bln}}</span><span>&nbsp;/&nbsp;</span>
                        <span
                          style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.thn}}</span><span>&nbsp;/</span>
                        <span>&nbsp;&nbsp;(dd/mm/yy)</span>
                      </span>
                    </td>
                  </tr>
<!--                  <tr>-->
<!--                    <td class="td-kiri px-2">Kewarganegaraan</td>-->
<!--                    <td>: <input class="checkbox-input readonly-checkbox" [checked]="true" type="checkbox" value="WNI"-->
<!--                        id="wni"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 30px;"-->
<!--                        for="wni">WNI</label>-->
<!--                      <input class="checkbox-input readonly-checkbox"-->
<!--                        [checked]="spajkBsi.warganegara==='NON-WNI'?true:false" type="checkbox" value="NON-WNI"-->
<!--                        id="nonwni"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 30px;"-->
<!--                        for="nonwni">Non WNI, sebutkan kewarganegaraannya</label>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <td class="td-kiri px-2">Jenis Kelamin</td>
                    <td>: <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.gender==='M'?true:false"
                        type="checkbox" value="Pria" id="pria"><label class="readonly-checkbox label-check-box px-1"
                        style="margin-right: 30px;" for="pria">Pria</label>
                      <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.gender==='F'?true:false"
                        type="checkbox" value="Wanita" id="wanita"><label class="readonly-checkbox label-check-box px-1"
                        style="margin-right: 30px;" for="wanita">Wanita</label>
                      <span class="px-2">Status:</span>
                      <input class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.statusPerkawinan==='M'?true:false" type="checkbox" value="M"
                        id="menikah"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 30px;"
                        for="menikah">Menikah</label>
                      <input class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.statusPerkawinan==='S'?true:false" type="checkbox" value="S"
                        id="belummenikah"><label class="readonly-checkbox label-check-box px-1"
                        style="margin-right: 30px;" for="belummenikah">Belum Menikah</label>
                      <input class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.statusPerkawinan==='W'?true:false" type="checkbox" value="W"
                        id="jandatawa"><label class="readonly-checkbox label-check-box px-1" style="margin-right: 30px;"
                        for="jandatawa">Janda/Duda</label>
                    </td>
                  </tr>
<!--                  <tr>-->
<!--                    <td class="td-kiri px-2">Nama Gadis Ibu Kandung</td>-->
<!--                    <td>: <span-->
<!--                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.motherMaidenName}}</span>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <td class="td-kiri px-2">Alamat Tempat Tinggal (Sesuai ID)</td>
                    <td> : <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.alamatPribadi}}</span><br>
                      <span>&nbsp;&nbsp;Kelurahan : </span><span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.kelurahan}}</span>
                      <span>&nbsp;&nbsp;Kecamatan : </span><span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.kecamatan}}</span>
                      <span>&nbsp;&nbsp;Kode Pos : </span><span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.kodePosPribadi}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Alamat Tempat Tinggal Saat ini</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.alamatDomisili}}</span><br>
                      <span>&nbsp;&nbsp;Kelurahan : </span><span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.domisiliKelurahan}}</span>
                      <span>&nbsp;&nbsp;Kecamatan : </span><span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.domisiliKecamatan}}</span>
                      <span>&nbsp;&nbsp;Kode Pos : </span><span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.kodePosDomisili}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">No. HP</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.nomorHPPribadi}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Nomor Aplikasi</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 56%;display: inline-block;">{{spajkBsi.nomorAplikasi}}</span>(No.
                      Aplikasi yang terdaftar pada Bank pemberi Fasilitas Pembiayaan) </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Pekerjaan/Uraian Pekerjaan</td>
                    <td> : <span
                        style="border-bottom: 1px solid;width: 34%;display: inline-block;">{{spajkBsi.pekerjaan}}</span>
                      <span style="width: 10%;display: inline-block;">Telp. Rumah:</span>
                      <span style="border-bottom: 1px solid black;width: 54%;display: inline-block; color: white">Telp.
                        Rumah</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Nama Tempat Kerja/Usaha</td>
                    <td> : <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.namaKantor}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Alamat Tempat Kerja/Usaha</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.alamatKantor}}</span>
                    </td>
                  </tr>
<!--                  <tr>-->
<!--                    <td class="td-kiri px-2">No. Telepon Tempat Kerja (Jika Ada)</td>-->
<!--                    <td>: <span-->
<!--                        style="border-bottom: 1px solid;width: 98%;display: inline-block;">{{spajkBsi.workPhNumber}}</span>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <td class="td-kiri px-2">Korespondensi Melalui Email</td>
                    <td>: <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.emailcorrespodensi==='Y'"
                        type="checkbox" value="Y" id="ya"><label class="readonly-checkbox label-check-box px-1"
                        style="margin-right: 30px;" for="ya">Ya</label>
                      <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.emailcorrespodensi==='N'"
                        type="checkbox" value="N" id="tidak"><label class="readonly-checkbox label-check-box px-1"
                        style="margin-right: 30px;" for="tidak">Tidak</label>
                      <span>Alamat Email: </span><span
                        style="border-bottom: 1px solid;width: 50%;display: inline-block;text-align: center;">{{spajkBsi.emailPribadi}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Sertifikat Asuransi Versi Elektronik</td>
                    <td>: <input class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.ecertificate==='Y'?true:false" type="checkbox" value="Y" id="ya"><label
                        class="readonly-checkbox label-check-box px-1" style="margin-right: 30px;" for="ya">Ya</label>
                      <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.ecertificate==='N'?true:false"
                        type="checkbox" value="N" id="tidak"><label class="readonly-checkbox label-check-box px-1"
                        style="margin-right: 30px;" for="tidak">Tidak</label>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-bottom: 20px;">
                <table style="border-collapse: collapse; width: 100%;border: 2px solid rgb(0, 0, 0);">
                  <tr>
                    <td colspan="4"
                      style="border-bottom: 2px solid black;font-size: 16px;padding-left: 10px; font-weight: bold; background-color: lightgray;">
                      2. PERINCIAN PERLINDUNGAN ASURANSI </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Usia Masuk Pihak Yang Diasuransikan</td>
                    <td colspan="3">: <span
                        style="border-bottom: 1px solid;width: 10%;display: inline-block;text-align: center;">{{spajkBsi.entryAge}}</span>
                      Tahun (<i>sesuai dengan Usia Nasabah pada kalkulator kontribusi</i>) </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Margin Fasilitas Pembiayaan Bank</td>
                    <td>: <span
                        style="border-bottom: 1px solid;width: 60%;display: inline-block;text-align: center;"></span>
                    </td>
                    <td style="width: 22%;">Tanggal Mulai Asuransi</td>
                    <td>
                      <span
                        style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.effDatetgl}}</span><span>&nbsp;/&nbsp;</span>
                      <span
                        style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.effDatebln}}</span><span>&nbsp;/&nbsp;</span>
                      <span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.effDatethn}}</span><span>&nbsp;/</span>
                      <span>&nbsp;&nbsp;(dd/mm/yy)</span>
<!--                    <td style="width: 22%;">Masa Asuransi</td>-->
<!--                    <td><span-->
<!--                      style="border-bottom: 1px solid;width: 27%;display: inline-block;text-align: center;">{{dataSpajk.tenure}}</span>-->
<!--                      Bulan </td>-->
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                    <td>Tanggal Berakhirnya Asuransi</td>
                    <td>
                      <span
                        style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.matDatetgl}}</span><span>&nbsp;/&nbsp;</span>
                      <span
                        style="border-bottom: 1px solid;width: 7%;display: inline-block;text-align: center;">{{spajkBsi.matDatebln}}</span><span>&nbsp;/&nbsp;</span>
                      <span
                        style="border-bottom: 1px solid;width: 15%;display: inline-block;text-align: center;">{{spajkBsi.matDatethn}}</span><span>&nbsp;/</span>
                      <span>&nbsp;&nbsp;(dd/mm/yy)</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2">Kontribusi Asuransi</td>
                    <td>: Rp. <span
                        style="border-bottom: 1px solid;width: 55%;display: inline-block;text-align: center;">{{dataSpajk.totalPremium
                        | number: '1.0-0'}}</span>
                    </td>
                    <td>Nilai Fasilitas Pembiayaan Awal</td>
                    <td>: Rp. <span
                      style="border-bottom: 1px solid;width: 30%;display: inline-block;text-align: center;">{{dataSpajk.kontribusiDasar
                      | number: '1.0-0'}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2" colspan="2">
                      <input class="checkbox-input readonly-checkbox" type="checkbox">
                      <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="ya">Nasabah Pembiayaan Tunggal</label>
                    </td>
                    <td>Nilai Pembiayaan Lainnya (Jelaskan)</td>
                    <td>: Rp. <span
                      style="border-bottom: 1px solid;width: 30%;display: inline-block;text-align: center;">{{dataSpajk.attributionSumAssured
                      | number: '1.0-0'}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-kiri px-2" colspan="2">
                      <input class="checkbox-input readonly-checkbox" type="checkbox">
                      <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="tidak">Nasabah Pembiayaan Pasangan</label>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="padding-bottom: 20px;">
                <table [cellPadding]="2" style="border-collapse: collapse; width: 100%;border: 2px solid rgb(0, 0, 0);">
                  <style>
                    .span-text {
                      padding-left: 20px;
                      display: inline-block;
                      width: 97%;
                    }

                    .ul-hurup {
                      height: 100%;
                      display: inline-block;
                      vertical-align: top;
                    }
                  </style>
                  <tr>
                    <td colspan="6"
                      style="border-bottom: 2px solid black;font-size: 16px;padding-left: 10px; font-weight: bold; background-color: lightgray;">
                      3. KETERANGAN KESEHATAN PIHAK YANG DIASURANSIKAN - Beri tanda (v) pada jawaban yang dipilih (Hanya
                      diisi jika Total Nilai Fasilitas Pembiayaan di atas Rp. 100,000,000) </td>
                  </tr>
                  <tr style="border-top: 2px solid black;background-color: lightgray;">
                    <td colspan="3" style="padding-left: 10px;">Apakah Total Nilai Fasilitas Pembiayaan lebih besar dari Rp. 100.000.000 dan/atau Usia Anda > 70 tahun?
                      <p class="mb-0"><i>(Rp. 100.000.001 atau lebih)</i></p>
                    </td>
                    <td colspan="3">
                      <div>
                        <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.healthQuestionFlag !== 'N'"
                          type="checkbox" value="Y" id="ya"><label class="readonly-checkbox label-check-box"
                          style="margin-right: 30px;" for="ya">Ya (Wajib isi pertanyaan poin 3.a hingga 3.g)</label>
                      </div>
                      <div>
                        <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.healthQuestionFlag == 'N'"
                          type="checkbox" value="N" id="tidak"><label class="readonly-checkbox label-check-box"
                          style="margin-right: 30px;" for="tidak">Tidak (Lanjut ke nomor 4)</label>
                      </div>
                    </td>
                  </tr>
                  <tr style="border-top: 2px solid black;">
                    <td colspan="4"></td>
                    <td
                      style="width: 6%;border-top: 1px solid; border-bottom: 1px solid;font-size: 14px; border-left: 1px solid;border-right: 1px solid;"
                      align="center">YA </td>
                    <td style="width: 6%;border-top: 1px solid; border-bottom: 1px solid;border-right: 1px solid;"
                      align="center">TIDAK </td>
                  </tr>
                  <tr style="vertical-align: top;">
                    <td style="padding-top: 5px;font-size: 14px;padding-left: 10px;"><span class="ul-hurup">a.</span>
                      <span class="span-text" style="width: 87%;">Tinggi Badan & Berat Badan</span>
                    </td>
                    <td colspan="3" style="padding-top: 5px;">
                      <span class="ul-hurup">: <span align="center"
                          style="font-size: 14px; margin-left: 10px;border-bottom: 1px solid; width: 50px;display: inline-block;">{{spajkBsi.height}}</span>
                        <span>cm & </span>
                        <span align="center"
                          style="font-size: 14px;border-bottom: 1px solid; width: 50px;display: inline-block;">{{spajkBsi.weight}}</span>
                        <span>Kg</span>
                      </span>
                      <span style="margin-left:80px;font-size: 14px; width: 67%;display:inline-block"> Berat badan
                        bertambah/berkurang dalam 12 bulan terakhir, <b>Jika “YA” jelaskan</b> kenaikan/penurunan berat
                        badan <span align="center"
                          style="border-bottom: 1px solid; width: 50px;display: inline-block;">{{spajkBsi.weightGainlossKg}}</span>
                        kg </span>
                    </td>
                    <td style="border: 1px solid black;font-size: 14px" align="center"><input
                        class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.weightGainlossFlag==='Y'?true:false" name="beratbadanya" type="checkbox"
                        value="Y" id="beratbadanya"></td>
                    <td style="border: 1px solid black;font-size: 14px" align="center"><input
                        class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.weightGainlossFlag==='N'?true:false" name="beratbadantdk" type="checkbox"
                        value="N" id="beratbadantdk"></td>
                  </tr>
                  <tr style="border-top: 2px solid black;">
                    <td class="td-depan-width" style="padding-left: 10px;">
                      <span class="ul-hurup">b.</span>
                      <span class="span-text" style="width: 87%;">Apakah Anda merokok?</span>
                    </td>
                    <!-- <td>:</td> -->
                    <td colspan="3">: <b style="margin-left: 10px;font-size: 14px">Jika "YA" Jelaskan</b> <span
                        align="center"
                        style="width:10%; display: inline-block; border-bottom: 1px solid;">{{spajkBsi.smokingPcs}}</span>Batang/Bungkus
                      per hari </td>
                    <td style="border: 1px solid black;font-size: 14px" align="center"><input
                        class="checkbox-input readonly-checkbox" [checked]="spajkBsi.smokingFlag==='Y'?true:false"
                        name="merokokya" type="checkbox" value="Y" id="rokokya"></td>
                    <td style="border: 1px solid black;font-size: 14px" align="center"><input
                        class="checkbox-input readonly-checkbox" [checked]="spajkBsi.smokingFlag==='N'?true:false"
                        name="merokoktdk" type="checkbox" value="N" id="rokoktdk"></td>
                  </tr>
                  <tr style="border-top: 2px solid black;">
                    <td style="padding-left: 10px;font-size: 14px" colspan="4">
                      <span class="ul-hurup">c.</span>
                      <span class="span-text"> Apakah Anda pernah/dianjurkan/sedang menjalani pengobatan atau perawatan
                        di Rumah Sakit untuk mengetahui atau menderita penyakit/keadaan sebagai berikut: : </span>
                    </td>
                    <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"><input
                        class="checkbox-input readonly-checkbox" [checked]="spajkBsi.preExistingFlag==='Y'"
                        name="preexistingya" type="checkbox" value="Y" id="preexistingya"></td>
                    <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"><input
                        class="checkbox-input readonly-checkbox" [checked]="spajkBsi.preExistingFlag==='N'"
                        name="preexistingtdk" type="checkbox" value="N" id="preexistingtdk"></td>
                  </tr>
                  <tr style="vertical-align: top;">
                    <style>
                      .td-ket-kes {
                        padding-left: 35px;
                      }
                    </style>
                    <td class="td-ket-kes">
                  <tr>
                    <td>
                      <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.chestPainFlag==='Y'"
                        type="checkbox" value="chestpain" id="chestpain">
                    </td>
                    <td>
                      <label class="readonly-checkbox label-check-box" for="chestpain">Sakit dada (Chest Pain)/Jantung &
                        Pembuluh Darah</label>
                    </td>
                  </tr>
              </td>
              <td>
            <tr>
              <td>
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.lungFlag === 'Y'" type="checkbox"
                  value="paru" id="paru">
              </td>
              <td>
                <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                  for="paru">Paru-paru/Gangguan Pernafasan</label>
              </td>
            </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.brainDisorderFlag === 'Y'"
                    type="checkbox" value="Segala jenis kelainan otak" id="kelainan-otak">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="kelainan-otak">Segala jenis kelainan otak</label>
                </td>
              </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.alcoholicFlag === 'Y'"
                    type="checkbox" value="Penggunaan/ketergantungan Alkohol" id="alkolholik">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="alkolholik">Penggunaan/ketergantungan Alkohol</label>
                </td>
              </tr>
            </td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="td-ket-kes">
            <tr>
              <td>
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.highBloodPresureFlag === 'Y'"
                  type="checkbox" value="kanker" id="kanker">
              </td>
              <td>
                <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="darting">Darah
                  Tinggi/Stroke</label>
              </td>
            </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.cancerFlag === 'Y'"
                    type="checkbox" value="Paru-paru" id="paru-paru">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="kanker">Kanker/Tumor/Kista</label>
                </td>
              </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.lymphGlandFlag === 'Y'"
                    type="checkbox" value="Kelenjar getah bening" id="kelenjar-getah-bening">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="kelenjar-getah-bening">Kelenjar Getah Bening/Tiroid</label>
                </td>
              </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.hivAidsFlag === 'Y'"
                    type="checkbox" value="AIDS/HIV" id="hiv-aids">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="hiv-aids">AIDS/HIV/Penyakit Menular Seksual</label>
                </td>
              </tr>
            </td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="td-ket-kes">
            <tr>
              <td>
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.kidneyFlag === 'Y'" type="checkbox"
                  value="ginjal" id="ginjal">
              </td>
              <td>
                <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="ginjal">Ginjal/Kandung
                  Kemih/Prostat</label>
              </td>
            </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.diabeticFlag === 'Y'"
                    type="checkbox" value="diabetes" id="diabetes">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="diabetes">Kencing
                    Manis</label>
                </td>
              </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.intestinesFlag === 'Y'"
                    type="checkbox" value="Lambung/usus" id="lambung-usus">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="lambung-usus">Lambung/usus</label>
                </td>
              </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.othersFlag === 'Y'?true:false"
                    type="checkbox" value="Lainnya, sebutkan" id="lainnya">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="lainnya">Lainnya,
                    sebutkan <span align="center"
                      style="width: 100px; display: inline-block;border-bottom: 1px solid;">{{spajkBsi.othersRemark}}</span></label>
                </td>
              </tr>
            </td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="td-ket-kes">
            <tr>
              <td>
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.bloodDisorderFlag === 'Y'"
                  type="checkbox" value="leukimia" id="leukimia">
              </td>
              <td>
                <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="leukimia">Kelainan
                  Darah/Anemia/Leukimia</label>
              </td>
            </tr>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.mentalDisorderFlag === 'Y'"
                    type="checkbox" value="depresi" id="depresi">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="depresi">Kelainan
                    Jiwa/Depresi</label>
                </td>
              </tr>
            <td colspan="2">
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.hepatitisFlag === 'Y'"
                    type="checkbox" value="Liver" id="liver">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="liver">Hepatitis/Liver</label>
                </td>
              </tr>
            </td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            </tr>
            <tr style="vertical-align: top;">
              <td class="td-ket-kes">
            <tr>
              <td>
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.cholesterolFlag==='Y'"
                  type="checkbox" value="Kolesterol" id="Kolesterol">
              </td>
              <td>
                <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="Kolesterol">Kolesterol
                  Tinggi</label>
              </td>
            </tr>
            </td>
            <td>
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.nervousDisorderFlag==='Y'"
                    type="checkbox" value="Kelainan Jiwa" id="epilepsi">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;" for="epilepsi">Gangguan
                    Sistem Saraf/Sendi/Tulang/Epilepsi</label>
                </td>
              </tr>
            </td>
            <td colspan="2">
              <tr>
                <td>
                  <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.drugAbuseFlag==='Y'"
                    type="checkbox" value="Penggunaan/ketergantungan Obat" id="drugAbuse">
                </td>
                <td>
                  <label class="readonly-checkbox label-check-box" style="margin-right: 30px;"
                    for="drugAbuse">Penggunaan/Ketergantungan Obat</label>
                </td>
              </tr>
            </td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center"></td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td colspan="4" style="padding-left: 10px;">
                <span class="ul-hurup">d.</span>
                <span class="span-text">Dalam 5 tahun terakhir, (i) Apakah Anda pernah disarankan untuk dirawat di rumah
                  sakit atau menjalani operasi bedah (selain flu biasa, atau komplikasi kehamilan atau operasi Caesar);
                  ATAU (ii) Apakah Anda mendapatkan hasil yang tidak normal dari pemeriksaan Kesehatan seperti USG,
                  mammogram, CT Scan, biopsy, pap smear, EKG, rontgen, hasil darah atau hasil urine yang disarankan
                  dokter untuk mengulang tes / pemeriksaan lanjutan? <b>Jika "Ya" jelaskan</b>
                  <span align="center"
                    style="width: 150px; display: inline-block;border-bottom: 1px solid;">{{dataSpajk.hospitalCareDesc}}</span>
                </span>
              </td>
              <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox" [checked]="dataSpajk.hospitalCareFlag == 'Y'"
                  name="permohonan" type="checkbox" value="Y" id="permohonanY">
              </td>
              <td style="border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox" [checked]="dataSpajk.hospitalCareFlag == 'N'"
                  name="permohonan" type="checkbox" value="Y" id="permohonanTdk">
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td colspan="4" style="padding-left: 10px;">
                <span class="ul-hurup">e.</span>
                <span class="span-text">Apakah Anda bermaksud mencari pendapat medis atau pernah disarankan untuk
                  menjalani pemeriksaan Kesehatan yang sedang berlangsung atau belum selesai (selain flu biasa,
                  kehamilan tanpa komplikasi)? <b>Jika "Ya" jelaskan</b>
                  <span align="center"
                    style="width: 150px; display: inline-block;border-bottom: 1px solid;">{{dataSpajk.medicalOpinionDesc}}</span>
                </span>
              </td>
              <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox" [checked]="dataSpajk.medicalOpinionFlag == 'Y'"
                  name="permohonan" type="checkbox" value="Y" id="permohonanY">
              </td>
              <td style="border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox" [checked]="dataSpajk.medicalOpinionFlag=='N'"
                  name="permohonan" type="checkbox" value="Y" id="permohonanTdk">
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td colspan="4" style="padding-left: 10px;">
                <span class="ul-hurup">f.</span>
                <span class="span-text">Apakah ada anggota keluarga terdekat Anda (Ayah, Ibu, Kakak, Adik) yang
                  menderita atau meninggal karena penyakit kanker, jantung, stroke, diabetes atau penyakit keturunan
                  lainnya sebelum usia 60 tahun? <b>Jika "Ya" jelaskan</b>
                  <span align="center"
                    style="width: 150px; display: inline-block;border-bottom: 1px solid;">{{spajkBsi.familyMedicalDesc}}</span>
                </span>
              </td>
              <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.familyMedicalFlag==='Y'"
                  name="permohonan" type="checkbox" value="Y" id="permohonanY">
              </td>
              <td style="border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox" [checked]="spajkBsi.familyMedicalFlag==='N'"
                  name="permohonan" type="checkbox" value="Y" id="permohonanTdk">
              </td>
            </tr>
            <tr style="border-top: 2px solid black;">
              <td colspan="4" style="padding-left: 10px;">
                <span class="ul-hurup">g.</span>
                <span class="span-text">Apakah permohonan perlindungan Asuransi Anda pernah ditolak, ditangguhkan atau
                  dikenakan kontribusi tambahan? <b>Jika "Ya" jelaskan</b>
                  <span align="center"
                    style="width: 150px; display: inline-block;border-bottom: 1px solid;">{{spajkBsi.insuranceRejectionDesc}}</span>
                </span>
              </td>
              <td style="border-left: 1px solid black;border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox"
                  [checked]="spajkBsi.insuranceRejectionFlag==='Y'?true:false" name="permohonan" type="checkbox"
                  value="Y" id="permohonanY">
              </td>
              <td style="border-right: 1px solid black;" align="center">
                <input class="checkbox-input readonly-checkbox"
                  [checked]="spajkBsi.insuranceRejectionFlag==='N'?true:false" name="permohonan" type="checkbox"
                  value="Y" id="permohonanTdk">
              </td>
            </tr>
          </table>
          </td>
          </tr>
          </table>
          <div class="row">
            <div class="col">
              <p class="text-start fs-7"><i>PT Asuransi Allianz Life Syariah IndonesiaSPAJ KumpulanSyariah/SmartProtection/SIO&GIO/</i></p>
            </div>
          </div>
        </div>
        <div class="page-break">
          <table>
            <tr>
              <td style="padding-bottom: 20px;">
                <table style="border-collapse: collapse; width: 100%;border: 2px solid rgb(0, 0, 0);">
                  <tr>
                    <td colspan="3"
                      style="border-bottom: 2px solid black;font-size: 16px;padding-left: 10px; font-weight: bold; background-color: lightgray;">
                      4. PERSETUJUAN PEMASARAN </td>
                  </tr>
                  <tr style="border-top: 2px solid black; vertical-align: top;">
                    <td style="text-align: justify;">
                      <span style="text-align: justify;width: 95%;display: inline-block;padding-left: 15px;"> Apakah
                        Anda (Pihak Yang Diasuransikan) bersedia (i) untuk menerima informasi, penawaran produk dan/atau
                        layanan serta dihubungi oleh Allianz Syariah, anak perusahaan dan/atau afiliasinya ("Grup
                        Allianz") (serta pihak ketiga yang ditunjuk oleh Grup Allianz); dan (ii) data pribadi Anda
                        diproses oleh Grup Allianz dan pihak ketiga yang ditunjuk oleh Grup Allianz untuk tujuan
                        pemasaran, peningkatan kualitas data pribadi serta peningkatan layanan? </span>
                    </td>
                    <td align="center">YA<input class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.marketingFlayYN==='Y'?true:false" name="pemasaranya" type="checkbox"
                        value="Y" id="pemasaranya"></td>
                    <td align="center">TIDAK<input class="checkbox-input readonly-checkbox"
                        [checked]="spajkBsi.marketingFlayYN==='N'?true:false" name="pemasarantdk" type="checkbox"
                        value="N" id="pemasarantdk"></td>
                  </tr>
                  <tr>
                    <td style="text-align: justify;" colspan="3">
                      <span style="display: inline-block;padding-left: 15px;width: 98%;">Dalam hal Anda menjawab "YA",
                        Anda mengerti dan menyetujui bahwa persetujuan diatas meliputi: (i) persetujuan untuk dihubungi
                        dan/atau dikirimkan informasi mengenai penawaran produk dan/atau layanan, survei nasabah dan
                        kampanye produk, melalui setiap media komunikasi yang tersedia (seperti surat, surat elektronik
                        (email), Short Message Service (SMS), telepon, aplikasi pesan singkat dan media komunikasi
                        digital/elektronik lainnya) oleh Grup Allianz (serta pihak ketiga yang ditunjuk oleh Grup
                        Allianz); dan (ii) persetujuan pemberian kuasa kepada Grup Allianz (serta pihak yang ditunjuk
                        oleh Grup Allianz) untuk mengungkapkan informasi data pribadi Anda kepada setiap pihak lainnya
                        terkait kepentingan yang dimaksud pada poin (i). </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" style="text-align: justify;">
                      <span style="display: inline-block;padding-left: 15px;width: 98%;"><b>Perhatian:</b> Dalam hal
                        Anda tidak lagi bersedia dihubungi dan menerima informasi penawaran produk dan/atau layanan Grup
                        Allianz (serta pihak ketiga yang ditunjuk oleh Grup Allianz), Anda dapat menghubungi AllianzCare
                        di 1500-136 atau mengirimkan email ke alamat Allianzcaresyariah@allianz.co.id </span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <style>
                  .grid {
                    width: 2%;
                    border: 1px solid gray;
                    height: 20px;
                    text-align: center;
                  }
                </style>
                <table style="border-collapse: collapse; width: 100%;border: 2px solid rgb(0, 0, 0);">
                  <tr>
                    <td colspan="6"
                      style="border-bottom: 2px solid black;font-size: 16px;padding-left: 10px; font-weight: bold; background-color: lightgray;">
                      5. Diisi oleh Staf Bank/Perusahaan Pemberi Pembiayaan </td>
                  </tr>
                  <tr style="border-top: 2px solid black;">
                    <td style="width: 16%;border-bottom: 2px solid black;" class="px-2">Email Staf Bank</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">
                      <table style="width: 100%;">
                        <tr>
                          <td class="grid">{{this.getCharatIndex(0)}}</td>
                          <td class="grid">{{this.getCharatIndex(1)}}</td>
                          <td class="grid">{{this.getCharatIndex(2)}}</td>
                          <td class="grid">{{this.getCharatIndex(3)}}</td>
                          <td class="grid">{{this.getCharatIndex(4)}}</td>
                          <td class="grid">{{this.getCharatIndex(5)}}</td>
                          <td class="grid">{{this.getCharatIndex(6)}}</td>
                          <td class="grid">{{this.getCharatIndex(7)}}</td>
                          <td class="grid">{{this.getCharatIndex(8)}}</td>
                          <td class="grid">{{this.getCharatIndex(9)}}</td>
                          <td class="grid">{{this.getCharatIndex(10)}}</td>
                          <td class="grid">{{this.getCharatIndex(11)}}</td>
                          <td class="grid">{{this.getCharatIndex(12)}}</td>
                          <td class="grid">{{this.getCharatIndex(13)}}</td>
                          <td class="grid">{{this.getCharatIndex(14)}}</td>
                          <td class="grid">{{this.getCharatIndex(15)}}</td>
                          <td class="grid">{{this.getCharatIndex(16)}}</td>
                          <td class="grid">{{this.getCharatIndex(17)}}</td>
                          <td class="grid">{{this.getCharatIndex(18)}}</td>
                          <td class="grid">{{this.getCharatIndex(19)}}</td>
                          <td class="grid">{{this.getCharatIndex(20)}}</td>
                          <td class="grid">{{this.getCharatIndex(21)}}</td>
                          <td class="grid">{{this.getCharatIndex(22)}}</td>
                          <td class="grid">{{this.getCharatIndex(23)}}</td>
                          <td class="grid">{{this.getCharatIndex(24)}}</td>
                          <td class="grid">{{this.getCharatIndex(25)}}</td>
                          <td class="grid">{{this.getCharatIndex(26)}}</td>
                          <td class="grid">{{this.getCharatIndex(27)}}</td>
                          <td class="grid">{{this.getCharatIndex(28)}}</td>
                          <td class="grid">{{this.getCharatIndex(29)}}</td>
                          <td class="grid">{{this.getCharatIndex(30)}}</td>
                          <td class="grid">{{this.getCharatIndex(31)}}</td>
                          <td class="grid">{{this.getCharatIndex(32)}}</td>
                          <td class="grid">{{this.getCharatIndex(33)}}</td>
                          <td class="grid">{{this.getCharatIndex(34)}}</td>
                          <td class="grid">{{this.getCharatIndex(35)}}</td>
                          <td class="grid">{{this.getCharatIndex(36)}}</td>
                          <td class="grid">{{this.getCharatIndex(37)}}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 2px solid black;" class="px-2">Bank/Perusahaan</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">
                      {{spajkBsi.companyName}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 2px solid black;" class="px-2">Kode Bank</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">BSI0524</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 2px solid black;" class="px-2">Cabang/Unit</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">
                      {{spajkBsi.areaKantorCabang}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 2px solid black;" class="px-2">Cabang Proses Fasilitas Pembiayaan</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">
                      {{spajkBsi.kantorCabang.split('-')[0]}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 2px solid black;" class="px-2">No. Polis</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">
                      {{spajkBsi.policynumber}}</td>
                  </tr>
                  <tr>
                    <td style="border-bottom: 2px solid black;" class="px-2">Tanggal Permohonan</td>
                    <td style="border-left: 2px solid black;border-bottom: 2px solid black;" colspan="5">
                      {{this.todayDate | date:"dd - M - Y"}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <div style="border: 2px solid black;" class="px-2 mt-3">
            <p class="text-center mx-0"><b><u>AKAD/KONTRAK SYARIAH</u></b></p>
            <p class="mb-0">Saya yang bertanda tangan di bawah ini, sebagai calon Pihak Yang Diasuransikan PT Asuransi Allianz Life Syariah Indonesia("Allianz Syariah"), dengan ini menyatakan dan menyetujui hal-hal sebagai berikut:</p>
            <ol class="mb-1">
              <li>Saya, dalam hal ini melalui Peserta, bersama dengan para peserta lainnya setuju untuk saling tolong menolong (ta’awun) terhadap musibah yang mungkin dialami oleh salah seorang di antara Pihak Yang Diasuransikan, dan untuk itu Saya bersedia memberikan IuranTabarru' untuk dimasukkan ke Dana Tabarru'.</li>
              <li>Saya, dalam hal ini melalui Peserta, dengan ini memberi kuasa kepada Allianz Syariah selaku penerima kuasa berdasarkan Akad Wakalah bil Ujrah untuk mengelola Asuransi Jiwa Pembiayaan Kumpulan Syariah termasuk melakukan kegiatan administrasi, underwriting, pembayaran klaim, pemasaran dan/atau investasi Dana Tabarru’ sesuai dengan dengan kuasa atau wewenang yang diberikan, ketentuan Polis dan ketentuan-ketentuan lainnya yang ditetapkan oleh Allianz Syariah. Untuk tujuan tersebut di atas, Saya dan Peserta memberikan izin kepada Allianz Syariah untuk mendelegasikan sebagian atau seluruh pengelolaan investasi kepada pihak lain sesuai dengan peraturan perundang-undangan yang berlaku, dan dengan ketentuan bahwa pengelolaan investasi tersebut dilakukan sesuai denganprinsip-prinsip syariah. Atas pelaksanaan kuasa tersebut, Allianz Syariah berhak mendapatkan Ujrah sebagaimana yang diatur dalam Polis ini.</li>
              <li>Besaran, pengenaan dan pemotongan Ujrah-Ujrah adalah sebagaimana yang tercantum dalam Polis</li>
              <li>Saya mengikhlaskan dan menyetujui bahwa jika terdapat Surplus Underwriting, maka hasil Surplus Underwriring tersebut dimasukkan ke dalam Dana Tabarru’. </li>
            </ol>
          </div>
          <div class="procuration">
            <p class="mb-2"><b><u>PERNYATAAN DAN SURAT KUASA</u></b></p>
            <div class="row">
              <div class="col-6">
                <p> Saya, sebagai Calon PYD (“Saya”), telah mengisi Surat Permohonan Asuransi Jiwa Pembiayaan Kumpulan
                  (“SPAJPK”) Syariah ini dengan benar dan jujur dan dengan ini pula menyatakan dan menyetujui : </p>
              </div>
              <div class="col-6"></div>
            </div>
            <div class="row">
              <div class="col-6">
                <ol type="1">
                  <li>
                    <p> Semua keterangan yang diberikan di dalam SPAJPK Syariah ini dan keterangan lain yang Saya
                      sampaikan kepada PT Asuransi Allianz Life Syariah Indonesia (selanjutnya disebut "Allianz
                      Syariah") atau kepada pemeriksa kesehatan yang ditunjuk oleh Allianz Syariah adalah benar sudah
                      Saya tuliskan di dalam SPAJPK Syariah ini (termasuk yang ditulis di dalam dokumen lainnya yang
                      menjadi kelengkapan dari permohonan asuransi ini, jika ada) dan tidak ada keterangan - keterangan
                      dan hal-hal lain yang Saya sembunyikan, serta Saya sendiri yang menandatangani SPAJPK Syariah ini.
                    </p>
                  </li>
                  <li>
                    <p> Pembayaran yang dilakukan oleh Saya untuk pembayaran Kontribusi berdasarkan SPAJPK Syariah ini
                      tidak berasal dari maupun digunakan untuk tujuan tindak pidana pencucian uang dan pendanaan
                      terorisme sebagaimana dimaksud UU No. 8 Tahun 2010 tentang Pencegahan Dan Pemberantasan Tindak
                      Pidana Pencucian Uang dan UU No. 9 Tahun 2013 tentang Pencegahan Dan Pemberantasan Tindak Pidana
                      Pendanaan Terorisme (dan/ atau perubahannya), termasuk tidak terlibat dan/atau terdapat dalam
                      daftar pendanaan proliferasi senjata pemusnah massal. Apabila ada indikasi pelanggaran atas
                      Undang-Undang dan ketentuan-ketentuan tersebut di atas, maka Allianz Syariah akan melaksanakan
                      kewajiban sesuai dengan ketentuan yang berlaku atau atas perintah Lembaga Negara yang berwenang,
                      termasuk melakukan kewajiban pelaporan dan memberikan laporan atas transaksi keuangan yang
                      mencurigakan. Dalam rangka memenuhi kewajiban Uji Tuntas Nasabah, Saya bersedia untuk memberikan
                      data yang diminta sesuai dengan peraturan yang berlaku dan Saya bersedia untuk melakukan
                      pengkinian data dalam hal terdapat perubahan data dikemudian hari. </p>
                  </li>
                  <li>
                    <p> Saya dengan ini mengerti dan memahami bahwa: </p>
                    <ol type="a">
                      <li>
                        <p> Allianz akan melakukan Pemrosesan Data Pribadi Saya. Pengertian: </p>
                        <ol type="i">
                          <li>
                            <p> Data Pribadi mencakup semua data dan/atau informasi yang tercantum dalam SPAJPK ini,
                              data dan/atau informasi Saya berikan kepada Allianz melalui sarana atau pihak manapun dari
                              waktu ke waktu dan data dan/atau informasi yang diperoleh oleh Allianz dari pihak ketiga
                              manapun; dan </p>
                          </li>
                        </ol>
                      </li>
<!--                      <li>-->
<!--                        <p> Dasar Pemrosesan Data Pribadi Saya oleh Allianz adalah satu atau lebih dari dasar-dasar-->
<!--                          Pemrosesan berikut ini: </p>-->
<!--                        <ol type="i">-->
<!--                          <li>-->
<!--                            <p> Pemenuhan kewajiban perjanjian untuk memenuhi permintaan Saya (yaitu pengajuan SPAJPK-->
<!--                              ini, dan penerbitan Polis); </p>-->
<!--                          </li>-->
<!--                          <li>-->
<!--                            <p> Pemenuhan kewajiban hukum Allianz sesuai dengan ketentuan peraturan perundang-undangan;-->
<!--                            </p>-->
<!--                          </li>-->
<!--                          <li>-->
<!--                            <p> Pemenuhan perlindungan kepentingan vital Saya; dan/atau </p>-->
<!--                          </li>-->
<!--                          <li>-->
<!--                            <p> Pemenuhan kepentingan yang sah lainnya dengan tetap memperhatikan tujuan, kebutuhan dan-->
<!--                              keseimbangan kepentingan Allianz dan Saya, </p>-->
<!--                          </li>-->
<!--                        </ol>-->
<!--                        <p> masing-masing dasar Pemrosesan tersebut adalah sebagaimana diatur dalam peraturan-->
<!--                          perundang-undangan yang mengatur pelindungan data pribadi di Indonesia. </p>-->
<!--                      </li>-->
                    </ol>
                  </li>
                </ol>
              </div>
              <div class="col-6">
                <ol style="list-style-type: none;">
                  <li>
                    <ol style="list-style-type: none;">
                      <li>
                        <ol type="i" start="2">
                          <li><p> Pemprosesan atau Memproses mencakup kegiatan pemerolehan, pengumpulan, pengolahan,
                            penganalisisan, penyimpanan, perbaikan,pembaruan, penampilan, pengumuman, transfer,
                            penyebarluasan, pengungkapan, penghapusan dan/atau pemusnahan Data Pribadi. </p></li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <ol type="a" start="2">
                    <li>
                      <p> Dasar Pemrosesan Data Pribadi Saya oleh Allianz adalah satu atau lebih dari dasar-dasar
                        Pemrosesan berikut ini: </p>
                      <ol type="i">
                        <li>
                          <p> Pemenuhan kewajiban perjanjian untuk memenuhi permintaan Saya (yaitu pengajuan SPAJPK
                            ini, dan penerbitan Polis); </p>
                        </li>
                        <li>
                          <p> Pemenuhan kewajiban hukum Allianz sesuai dengan ketentuan peraturan perundang-undangan;
                          </p>
                        </li>
                        <li>
                          <p> Pemenuhan perlindungan kepentingan vital Saya; dan/atau </p>
                        </li>
                        <li>
                          <p> Pemenuhan kepentingan yang sah lainnya dengan tetap memperhatikan tujuan, kebutuhan dan
                            keseimbangan kepentingan Allianz dan Saya, </p>
                        </li>
                      </ol>
                      <p> masing-masing dasar Pemrosesan tersebut adalah sebagaimana diatur dalam peraturan
                        perundang-undangan yang mengatur pelindungan data pribadi di Indonesia. </p>
                    </li>
                    <li>
                      <p> Pemrosesan Data Pribadi Saya oleh Allianz adalah dalam rangka dan/atau untuk setiap tujuan
                        berikut ini ("Tujuan Pemrosesan”): </p>
                      <ol type="i">
                        <li>
                          <p> proses pengajuan permohonan asuransi; </p>
                        </li>
                        <li>
                          <p> penerbitan Polis; </p>
                        </li>
                        <li>
                          <p> penilaian risiko asuransi; </p>
                        </li>
                        <li>
                          <p> kegiatan operasional Allianz; </p>
                        </li>
                        <li>
                          <p> pengajuan dan penanganan setiap klaim (termasuk namun tidak terbatas pada pemeriksaan
                            dan investigasi klaim); </p>
                        </li>
                        <li>
                          <p> pembayaran manfaat asuransi/klaim; </p>
                        </li>
                        <li>
                          <p> keperluan ko-asuransi termasuk penanganan klaim yang timbul atas ko-asuransi; </p>
                        </li>
                        <li>
                          <p> pelayanan nasabah termasuk penanganan keluhan/komplain; </p>
                        </li>
                        <li>
                          <p> pembayaran komisi; </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </ol>
              </div>
            </div>
            <p class="text-start fs-7"><i>PT Asuransi Allianz Life Syariah IndonesiaSPAJ KumpulanSyariah/SmartProtection/SIO&GIO/</i></p>
          </div>
        </div>
        <div class="page-break">
          <div class="procuration pb-0">
            <div class="row">
              <div class="col-6">
                <ul style="list-style-type: none;">
                  <li>
                    <ol style="list-style-type: none;">
                      <li>
                        <ol type="i" start="10">
                          <li>
                            <p> kerja sama terkait proses permohonan asuransi dan/atau klaim (baik permohonan asuransi
                              dan/atau klaim yang Saya ajukan di Allianz atau perusahaan asuransi lainnya); </p>
                          </li>
                          <li>
                            <p> kerja sama dalam rangka penemuan atau pencegahan penipuan dan kejahatan keuangan; </p>
                          </li>
                          <li>
                            <p> setiap proses hukum yang melibatkan Allianz dan/atau tenaga pemasarnya </p>
                          </li>
                          <li>
                            <p> kerja sama reasuransi dan/atau retrosesi; </p>
                          </li>
                          <li>
                            <p> menanggapi perintah pengadilan atau proses hukum atau permintaan dari regulator manapun
                              atau pihak berwenang atau untuk melindungi terhadap penipuan atau aktivitas ilegal lainnya
                              atau untuk tujuan manajemen risiko atau untuk memungkinkan Allianz untuk melakukan upaya
                              hukum yang tersedia atau membatasi kerusakan yang mungkin terjadi terhadap Allianz,
                              dan/atau mematuhi hukum dan proses hukum termasuk tetapi tidak terbatas pada peraturan
                              tentang FATCA dan CRS (“Kebutuhan Pelaporan Pertukaran Informasi Antar Negara”); </p>
                          </li>
                          <li>
                            <p> kepatuhan terhadap perintah pengadilan, hukum dan peraturan perundang-undangan yang
                              berlaku; dan/atau </p>
                          </li>
                          <li>
                            <p> proses lainnya yang terkait dengan penyelenggaraan kegiatan asuransi. </p>
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <ol type="a" start="4">
                      <li>
                        <p> Allianz dapat mengungkapkan Data Dribadi Saya kepada pihak-pihak berikut ini (selanjutnya
                          disebut “Pihak Terkait”) dalam rangka dan/atau untuk setiap Tujuan Pemrosesan: </p>
                        <ol type="i">
                          <li>
                            <p> ahli medis dan/atau pihak ketiga lainnya (termasuk mereka yang memberikan perawatan,
                              pelayanan kesehatan dan/atau layanan lainnya kepada Saya); </p>
                          </li>
                          <li>
                            <p> setiap perusahaan (termasuk perusahaan penyedia layanan, perusahaan asuransi, dan
                              perusahaan reasuransi), mitra, orang atau pihak ketiga yang ditunjuk dan/atau bekerja sama
                              dengan Allianz; </p>
                          </li>
                          <li>
                            <p> perusahaan induk Allianz, afiliasi, anak perusahaan, agen dan perwakilannya dan/atau
                              usaha patungan; dan/atau </p>
                          </li>
                          <li>
                            <p> otoritas, asosiasi asuransi, pengadilan, pihak yang berwenang dan/atau badan pemerintah
                              (regulator) manapun </p>
                          </li>
                        </ol>
                      </li>
                      <li>
                        <p> Dalam rangka dan/atau untuk setiap Tujuan Pemrosesan, Allianz juga dapat: </p>
                        <ol type="i">
                          <li>
                            <p> melakukan transfer Data Pribadi Saya kepada setiap Pihak Terkait yang berada di luar
                              wilayah hukum Republik Indonesia; dan/atau </p>
                          </li>
                          <li>
                            <p> menunjuk setiap Pihak Terkait sebagai prosesor untuk melakukan Pemrosesan Data Pribadi
                              Saya. </p>
                            <p> Saya mengerti dan setuju bahwa masing-masing dasar Pemrosesan sebagaimana dijelaskan dalam
                              butir 3(b) di atas adalah sebagaimana diatur dalam peraturan perundang-undangan yang mengatur
                              pelindungan data pribadi di Indonesia dan merupakan dasar hukum yang sah atas Pemrosesan
                              seluruh Data Pribadi Saya. </p>
                          </li>
                        </ol>
                      </li>
                    </ol>
                  </li>
                </ul>
                <ol start="4" type="1">
                  <li>
                    <p> Saya juga bersedia untuk memberikan informasi/dokumen yang diperlukan guna memenuhi Kebutuhan
                      Pelaporan Pertukaran Informasi Antar Negara (“Informasi Terkait”) dan dengan segera menyampaikan
                      pengkinian data kepada Allianz jika ada perubahan atas Informasi Terkait tersebut. </p>
                  </li>
                  <li>
                    <p> Bahwa apabila ternyata pernyataan, keterangan, dokumen dan jawaban yang Saya berikan tidak benar
                      / diragukan kebenarannya, maka Saya memahami serta menyetujui sepenuhnya bahwa Sertifikat Asuransi
                      menjadi batal dan Allianz Syariah dibebaskan dari segala kewajibannya membayar Santunan Asuransi,
                      segala gugatan, tuntutan, klaim atau bagian dari itu dalam bentuk dan nama apapun, maupun
                      mengembalikan Kontribusi, baik saat ini maupun di kemudian hari. </p>
                  </li>
                  <li>
                    <p> Perlindungan asuransi akan mulai berlaku penuh bila hal-hal berikut ini dipenuhi </p>
                    <ol type="a">
                      <li>
                        <p> Perlindungan atas Pihak Yang Diasuransikan mulai berlaku terhitung sejak tanggal Fasilitas
                          Pembiayaan dicairkan oleh Peserta kepada Pihak Yang Diasuransikan. </p>
                      </li>
                      <li>
                        <p> Kontribusi beserta Ujrah lainnya (apabila ada), telah dibayar lunas. </p>
                      </li>
                    </ol>
                  </li>
                </ol>
              </div>
              <div class="col-6">
                <ol start="7" type="1">
                  <li>
                    <p> Saya, dengan ini memberi kuasa kepada: </p>
                    <ol type="a">
                      <li>
                        <p> setiap dokter, rumah sakit, klinik, puskesmas, instansi lain, perusahaan asuransi, badan
                          hukum, perorangan atau organisasi lainnya, yang mempunyai catatan atau mengetahui keadaan atau
                          kesehatan Saya, , riwayat pengobatan atau perawatan dirumah sakit, nasihat-nasihat dokter baik
                          selama Saya masih hidup atau meninggal dunia; dan/atau </p>
                      </li>
                      <li>
                        <p> setiap dokter, rumah sakit, klinik, puskesmas, instansi lain, perusahaan asuransi, badan
                          hukum, perorangan atau organisasi lainnya yang ditunjuk atau direkomendasikan oleh Allianz
                          Syariah, untuk memberitahu dan mengungkapkan kepada Allianz Syariah atau mereka yang diberi
                          kuasa olehnya, segala keterangan mengenai diri dan kesehatan Saya, suami/istri, atau
                          putra/putri Saya. </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p> Saya dengan ini melepaskan ketentuan-ketentuan yang termaktub dalam Pasal 1813, 1814, dan 1816
                      Kitab Undang-Undang Hukum Perdata, serta pemberian kuasa ini tidak dapat ditarik kembali dan
                      mengikat para pengganti/ahli waris/ penerusnya dan orang yang ditunjuk dan tetap berlaku setelah
                      Saya meninggal atau dalam keadaan cacat atau berada di bawah pengampuan. Salinan (fotokopi) surat
                      kuasa ini adalah sah dan mempunyai kekuatan hukum yang sama seperti aslinya. </p>
                  </li>
                  <li>
                    <p> Saya telah mendapatkan penjelasan dan sepenuhnya mengerti serta menerima bahwa apabila Saya
                      membatalkan Sertifikat Asuransi dalam jangka waktu 14 (empat belas) hari sejak Sertifikat Asuransi
                      Saya terima, maka Allianz Syariah wajib mengembalikan paling sedikit sejumlah Kontribusi yang
                      telah Saya bayarkan dikurangi Ujrah pencetakan dan pengiriman Sertifikat Asuransi, serta Ujrah
                      pemeriksaan kesehatan Pihak Yang Diasuransikan (apabila ada). </p>
                  </li>
                  <li>
                    <p> Saya menyadari sepenuhnya bahwa Allianz Syariah memiliki hak untuk menolak / menerima,
                      membatalkan / mengubah (dalam hal ini termasuk untuk menambahkan / mengurangi) ketentuan dalam
                      perjanjian perlindungan ini, termasuk antara lain untuk menentukan bahwa apabila Pihak Yang
                      Diasuransikan ditolak kepesertaannya oleh Allianz Syariah, maka seluruh Kontribusi yang dibayarkan
                      dikembalikan dikurangi Ujrah (apabila ada). </p>
                  </li>
                  <li>
                    <p> Saya mengerti bahwa dalam kapasitas Saya sebagai Pihak Yang Diasuransikan, Saya dapat
                      membatalkan perlindungan ini dan berhak untuk menerima Kontribusi yang sudah dibayarkan dikurangi
                      Ujrah (apabila ada). </p>
                  </li>
                  <li>
                    <p> Saya sadar dan sudah mengetahui serta memahami sepenuhnya produk yang akan dibeli dan segala
                      risiko atas produk tersebut dan Saya telah mendapatkan penjelasan atas produk yang akan Saya beli
                      dan segala risiko atas produk tersebut berdasarkan SPAJPK Syariah ini. </p>
                  </li>
                  <li>
                    <p> Dalam hal Saya memilih korespondensi melalui email dan/atau Sertifikat Asuransi versi elektronik
                      sebagaimana keterangan yang Saya berikan dalam SPAJPK Syariah ini, maka Saya menyatakan dan
                      menyetujui setiap bentuk korespondensi dan/atau Sertifikat Asuransi versi elektronik dikirimkan
                      melalui email. </p>
                  </li>
                  <li>
                    <p> Saya mengerti bahwa untuk mempelajari lebih lanjut tentang bagaimana Allianz Syariah melindungi
                      data pribadi dan hak-hak Saya dengan mengakses tautan berikut:
                      https://www.allianz.co.id/kebijakan-privasi.html.</p>
                  </li>
                  <li>
                    <p>Saya mengakui dan menyetujui bahwa SPAJPK
                      Syariah ini dapat ditandatangani dengan tanda tangan elektronik (baik seluruhnya atau sebagian), yang harus dianggap sebagai
                      tanda tangan asli untuk semua tujuan dan yang memiliki kekuatan hukum yang sama dengan tanda
                      tangan asli (basah). Saya mengakui dan menyetujui bahwa, dalam setiap proses hukum dalam setiap
                      hal yang sehubungan dengan SPAJPK Syariah ini dan/atau produk asuransi dan/atau permohonan ini,
                      Saya secara tegas mengesampingkan setiap hak untuk (i) mengajukan pembelaan atau pelepasan
                      tanggung jawab / kewajiban; dan/atau (ii) membatalkan SPAJPK Syariah ini, atas alasan
                      penandatanganan SPAJPK Syariah ini oleh Saya dengan tanda tangan elektronik.</p>
                  </li>
                  <li>
                    <p>
                      Dengan menandatangani
                      SPAJPK Syariah ini, maka Saya telah menyetujui pernyataan dan kuasa ini.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
            <div class="row ms-2">
              <div class="col-6">
                <div class="row">
                  <div class="col-5 pe-0">
                    <p>Tempat/Ditandatangani di</p>
                  </div>
                  <div class="col-7">
                    <p>: <span class="field-underline">______________________________________</span></p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-5">
                    <p>Tanggal</p>
                  </div>
                  <div class="col-7">
                    <p>: <span class="field-underline"> {{this.todayDate | date:"dd - MM - YYYY" }}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="signature">
            <div class="row">
              <div class="col-6">
                <p class="mt-2 text-start"> Saya yang bertanda tangan di bawah ini menyatakan bahwa pemberian fasilitas pembiayaan
                  syariah kepada Pihak Yang Diasuransikan telah sesuai dengan prosedur standar yang dimiliki oleh Bank.
                </p>
                <p>
                  <b>
                    <u> Staf Bank Pemberi Referensi </u>
                  </b>
                </p>
                <p>{{this.dataSpajk.salesName}}</p>
                <p class="mb-2"> (Tanda Tangan dan Nama Jelas Staf Bank) </p>
              </div>
              <div class="col-6">
                <p>
                  <b>
                    <u>Calon Pihak Yang Diasuransikan</u>
                  </b>
                </p>
                <p>({{spajkBsi.namaLengkap}})</p>
                <p class="mb-2">(Tanda tangan dan Nama Jelas Calon Pihak Yang Diasuransikan)</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="text-start fs-7"><i>PT Asuransi Allianz Life Syariah IndonesiaSPAJ KumpulanSyariah/SmartProtection/SIO&GIO/</i></p>
            </div>
          </div>
        </div>
      </div>
      <!-- end of spajk -->
      <!-- ================================================================================ -->
      <div class="riplay-label">
        <h3>RIPLAY PERSONAL</h3>
      </div>
      <!-- ================================================================================ -->
      <div class="riplay-view" #riplayView>
        <!-- page 1 -->
        <div class="page-break">
          <!-- header -->
          <div class="row header mb-1">
            <div class="col-3">
              <div class="row">
                <div class="col-8">
                  <img
                    src="data:image;base64,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"
                    alt="Allianz Logo">
                </div>
                <div class="col-4">
                  <p>Allianz</p>
                  <p>Syariah</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>PT Asuransi Allianz Life Syariah Indonesia berizin dan diawasi oleh Otoritas Jasa Keuangan</p>
                </div>
              </div>
            </div>
            <div class="col-9">
              <p><b>PT Asuransi Allianz Life Syariah Indonesia</b></p>
              <p><b>RINGKASAN INFORMASI PRODUK DAN LAYANAN (RIPLAY) PERSONAL</b></p>
              <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'"><b>SmartProtection Mitraguna BSI</b></p>
              <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'"><b>SmartProtection Pensiun Berkah BSI</b></p>
            </div>
          </div>
          <!-- content of Page 1-->
          <div class="row">
            <!-- left section of Page 1-->
            <div class="col-4 left-section-page-1 mt-3 mb-5">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-2">
                      <img
                        src="data:image/png;base64,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"
                        alt="Participant Data Icon">
                    </div>
                    <div class="col-10">
                      <p><b>DATA PERUSAHAAN DAN PESERTA</b></p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">Peserta</div>
                    <div class="col-8">: {{spajkBsi.companyName}}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">Nama Produk</div>
                    <div class="col-8" *ngIf="spajkBsi.productcode==='SPKTAMBSI'">: SmartProtection Mitraguna BSI</div>
                    <div class="col-8" *ngIf="spajkBsi.productcode==='SPKTAPBSI'">: SmartProtection Pensiun Berkah BSI
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">Jenis Produk</div>
                    <div class="col-8">: Asuransi Jiwa Pembiayaan Kumpulan</div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-4">Mata Uang</div>
                    <div class="col-8">: Rupiah</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p class="mb-1" *ngIf="spajkBsi.productcode==='SPKTAMBSI'"><b>SmartProtection Mitraguna BSI</b></p>
                  <p class="mb-1" *ngIf="spajkBsi.productcode==='SPKTAPBSI'"><b>SmartProtection Pensiun Berkah BSI</b>
                  </p>
                  <p class="mb-1" *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> SmartProtection Mitraguna BSI merupakan
                    produk Asuransi Jiwa Pembiayaan Kumpulan Syariah yang memberikan Perlindungan Pembiayaan dengan
                    Asuransi Berjangka Menurun bagi Pihak Yang Diasuransikan apabila terjadi risiko meninggal dunia
                    karena sakit dan/atau kecelakaan di masa mendatang.</p>
                  <p class="mb-1" *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> SmartProtection Pensiun Berkah BSI
                    merupakan produk Asuransi Jiwa Pembiayaan Kumpulan Syariah yang memberikan Perlindungan Pembiayaan
                    dengan Asuransi Berjangka Menurun bagi Pihak Yang Diasuransikan apabila terjadi risiko meninggal
                    dunia karena sakit dan/atau kecelakaan di masa mendatang.</p>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Usia Masuk Pihak Yang Diasuransikan</b></p>
                    </div>
                    <div class="col-5">
                      <p><b>: {{spajkBsi.entryAge}} Tahun</b></p>
                    </div>
                  </div>
                  <p class="bottom-note mb-1">(Sesuai dengan usia Pihak Yang Diasuransikan pada kalkulator kontribusi)
                  </p>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Kontribusi</b></p>
                    </div>
                    <div class="col-5">
                      <p><b>: Rp {{dataSpajk.totalPremium | number: '1.0-0'}}</b></p>
                    </div>
                  </div>
                  <p class="bottom-note mb-1">(Sesuai perhitungan pada kalkulator kontribusi)</p>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Masa Asuransi</b></p>
                    </div>
                    <div class="col-5">
                      <p><b>: {{dataSpajk.tenure}} Bulan</b></p>
                    </div>
                  </div>
                  <p class="bottom-note mb-1">(Sesuai dengan tenor pembiayaan)</p>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Nilai Pembiayaan Awal</b></p>
                    </div>
                    <div class="col-5">
                      <p><b>: Rp {{dataSpajk.kontribusiDasar | number: '1.0-0'}}</b></p>
                    </div>
                  </div>
                  <p class="bottom-note mb-1">(Sesuai dengan nilai pencairan pembiayaan) </p>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Nilai Biaya Atribusi Awal</b></p>
                    </div>
                    <div class="col-5">
                      <p><b>: Rp {{dataSpajk.attributionSumAssured | number: '1.0-0'}}</b></p>
                    </div>
                  </div>
                  <p class="bottom-note mb-1">(Sesuai dengan nilai pencairan pembiayaan)</p>
                  <div class="row">
                    <div class="col-6">
                      <p><b>Cara Pembayaran Kontribusi</b></p>
                    </div>
                    <div class="col-5">
                      <p><b>: Sekaligus</b></p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <p class="mb-1"><b>Mata Uang</b></p>
                    </div>
                    <div class="col-5">
                      <p class="mb-1"><b>: Rupiah</b></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p><i>Ujrah</i></p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'"><i>Ujrah</i> adalah sebesar 32% (tiga puluh dua persen)
                    dari Kontribusi. <i>Ujrah</i> tersebut termasuk namun tidak terbatas pada <i>ujrah</i> pengelolaan
                    risiko, <i>ujrah</i> akuisisi, <i>ujrah</i> administrasi, <i>ujrah</i> dalam rangka penutupan Polis,
                    <i>ujrah</i> pencetakan dan pengiriman Polis, Sertifikat Asuransi, pemeriksaan kesehatan,
                    pemeliharaan dan/atau pelaksanaan Polis, bea meterai, dan <i>ujrah-ujrah</i> lainnya, apabila ada.
                  </p>
                  <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'"><i>Ujrah</i> adalah sebesar 25,5% (dua puluh lima koma
                    lima persen) dari Kontribusi. <i>Ujrah</i> tersebut termasuk namun tidak terbatas pada <i>ujrah</i>
                    pengelolaan risiko, <i>ujrah</i> akuisisi, <i>ujrah</i> administrasi, <i>ujrah</i> dalam rangka
                    penutupan Polis, <i>ujrah</i> pencetakan dan pengiriman Polis, Sertifikat Asuransi, pemeriksaan
                    kesehatan, pemeliharaan dan/atau pelaksanaan Polis, bea meterai, dan <i>ujrah-ujrah</i> lainnya,
                    apabila ada. </p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Manfaat Asuransi</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <ol>
                    <li>
                      <p><b>Manfaat Meninggal Dunia</b></p>
                      <p class="mb-2">Membayar Santunan Asuransi Manfaat Meninggal Dunia menurun mengikuti sisa
                        pembiayaan pokok + margin bulan berjalan maksimal 1 bulan (jika ada) sejak Pihak Yang
                        Diasuransikan meninggal atau maksimum sebesar Nilai Fasilitas Pembiayaan Awal kepada Bank, jika
                        Pihak Yang Diasuransikan meninggal dunia karena sebab alami dan/atau Penyakit dan/atau
                        kecelakaan.</p>
                      <p class="mb-2">Santunan Asuransi Meninggal Dunia yang dibayarkan adalah mengikuti Tabel Penurunan
                        Santunan Asuransi Manfaat Meninggal Dunia dari Allianz Syariah.</p>
                    </li>
                    <li>
                      <p><b>Manfaat Atribusi* (pilihan)</b></p>
                      <p class="mb-2">Membayar Santunan Asuransi Manfaat Atribusi menurun mengikuti sisa Atribusi (jika
                        ada) setelah Pihak Yang Diasuransikan meninggal atau maksimum sebesar Atribusi awal kepada Bank,
                        jika Pihak Yang Diasuransikan meninggal dunia karena sebab alami dan/atau Penyakit dan/atau
                        kecelakaan.</p>
                      <p class="mb-2">Santunan Asuransi Atribusi yang dibayarkan adalah mengikuti Tabel Penurunan
                        Santunan Asuransi Manfaat Atribusi dari Allianz Syariah..</p>
                    </li>
                  </ol>
                  <p class="tiny-note mb-1">Santunan Asuransi tidak termasuk tunggakan dan/atau margin/denda yang timbul
                    dari tunggakan.</p>
                  <p class="tiny-note">*Atribusi adalah biaya yang diamortisasikan selama jangka waktu pembiayaan. Biaya
                    atribusi yang menjadi nilai perlindungan asuransi adalah biaya yang menjadi beban nasabah pembiayaan
                    baik yang dibayar di muka oleh nasabah pembiayaan maupun yg diberikan talangan oleh Bank, termasuk
                    namun tidak terbatas pada Kontribusi, serta penalti.</p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Akad</p>
                </div>
              </div>
            </div>
            <!-- middle section of Page 1-->
            <div class="col-4 middle-section-page-1 mt-3 mb-5">
              <div class="row">
                <div class="col">
                  <p><b>Akad Tabarru'</b></p>
                  <p class="mb-2">Akad hibah dalam bentuk pemberian Iuran Tabarru’ dari Pihak Yang Diasuransikan melalui
                    Peserta kepada Dana Tabarru’ untuk tujuan tolong menolong di antara para Pihak Yang Diasuransikan
                    sebagaimana diatur dalam Polis, yang tidak bersifat dan bukan untuk tujuan komersial. Iuran
                    <i>Tabarru’</i> sebesar <span *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> 68% </span>
                    <span *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> 74.5% </span> dari Kontribusi yang dibayarkan.
                  </p>
                  <p><b>Akad Wakalah bil Ujrah</b></p>
                  <p>Akad antara Pihak Yang Diasuransikan (dalam hal ini melalui Peserta) dan Allianz Syariah yang
                    memberikan kuasa kepada perusahaan asuransi syariah sebagai wakil dari para Pihak Yang Diasuransikan
                    untuk mengelola asuransi jiwa syariah (termasuk dalam hal ini Asuransi Jiwa Pembiayaan Kumpulan
                    Syariah), termasuk untuk melakukan kegiatan administrasi, <i>underwriting</i>, pembayaran klaim,
                    pemasaran, dan/atau investasi Dana <i>Tabarru’</i>, masing-masing sesuai dengan kuasa atau wewenang
                    yang diberikan dan ketentuan-ketentuan lainnya yang ditetapkan oleh perusahaan asuransi syariah dan
                    dengan imbalan berupa <i>Ujrah</i>.</p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Risiko</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p><b>Risiko Pembiayaan</b></p>
                  <p>Dalam hal ini PT Asuransi Allianz Life Syariah Indonesia (“Allianz Syariah”) bertindak selaku
                    penyeleksi risiko dari produk asuransi. Risiko pembiayaan berkaitan dengan kemampuan membayar dari
                    Allianz Syariah yang merupakan kewajiban dari Allianz Syariah terhadap nasabahnya. Allianz Syariah
                    telah berhasil mempertahankan kinerjanya untuk melebihi minimum kecukupan modal yang ditentukan oleh
                    Pemerintah.</p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Pengembalian Kontribusi</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p class="mb-2">Apabila (a) Pihak Yang Diasuransikan melunasi Fasilitas Pembiayaan sebelum tanggal
                    jatuh tempo pelunasan Fasilitas Pembiayaan; atau (b) Allianz Syariah membatalkan atau mengakhiri
                    Polis dan/atau Sertifikat Asuransi (selain karena alasan yang tercantum dalam Polis, Allianz Syariah
                    berkewajiban untuk mengembalikan sisa Kontribusi untuk Masa Asuransi yang belum terlewati kepada
                    Pihak Yang Diasuransikan melalui Peserta sesuai dengan formula pengembalian Kontribusi, sebagai
                    berikut. </p>
                  <p class="mb-2"><b>[(n-t)/n] x Kontribusi x 45%</b></p>
                  <div class="row mb-2">
                    <div class="col-2">
                      <p class="bottom-note">Catatan:</p>
                    </div>
                    <div class="col-10">
                      <p class="bottom-note">n = Masa Asuransi (bulan)</p>
                      <p class="bottom-note">t = Durasi Masa Asuransi yang sudah dilalui (bulan)</p>
                    </div>
                  </div>
                  <p>Pengembalian Kontribusi akan dilakukan oleh Allianz Syariah setelah dikurangi ujrah-ujrah yang
                    diperlukan sehubungan dengan pemeliharaan dan/atau pelaksanaan Polis ini.</p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Surplus <i>Underwriting</i></p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Jika terjadi Surplus Underwriting, Pengelola akan memasukkan hasil Surplus Underwriting tersebut ke
                    dalam Dana Tabarru’.</p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Fitur Utama Asuransi Jiwa Pembiayaan Kumpulan Syariah</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-6">
                      <ul>
                        <li>
                          <p><b>Usia Masuk Pihak Yang Diasuransikan</b></p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-1">
                      <p class="text-right">:</p>
                    </div>
                    <div class="col-5">
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">18 Tahun – 69 Tahun (ulang tahun terakhir)</p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">45 Tahun – 74 Tahun (ulang tahun terakhir)</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <ul>
                        <li>
                          <p><b>Masa Asuransi</b></p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-1">
                      <p class="text-right">:</p>
                    </div>
                    <div class="col-5">
                      <p>1 bulan - 180 bulan</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <ul>
                        <li>
                          <p><b>Maksimum Usia Perlindungan</b></p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-1">
                      <p class="text-right">:</p>
                    </div>
                    <div class="col-5">
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">70 Tahun</p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">75 Tahun</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <ul>
                        <li>
                          <p><b>Nilai Fasilitas Pembiayaan Awal</b></p>
                          <p class="bottom-note">(Santunan Asuransi Manfaat Meninggal Dunia awal)</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-1">
                      <p class="text-right">:</p>
                    </div>
                    <div class="col-5">
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">Rp5 Juta – Rp1,5 Miliar Untuk Dokter Spesialis
                        hingga Rp2 Miliar.</p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">Rp10 Juta – Rp350 Juta.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- right section of Page 1-->
            <div class="col-4 right-section-page-1 mt-3 mb-5">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-6">
                      <ul>
                        <li>
                          <p><b>Mata Uang</b></p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-1">
                      <p class="text-right">:</p>
                    </div>
                    <div class="col-5">
                      <p>Rupiah</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6" style="text-align: left;">
                      <ul>
                        <li>
                          <p><b>Cara Pembayaran Kontribusi</b></p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-1">
                      <p class="text-right">:</p>
                    </div>
                    <div class="col-5">
                      <p>Sekaligus</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <ul>
                        <li>
                          <p><b>Masa Tunggu</b></p>
                          <p style="text-align: justify;" *ngIf="spajkBsi.productcode === 'SPKTAMBSI'">30 hari sejak
                            tanggal mulai berlakunya asuransi untuk seorang Pihak Yang Diasuransikan, kecuali Pihak Yang
                            Diasuransikan meninggal dunia akibat kecelakaan.</p>
                          <p style="text-align: justify;" *ngIf="spajkBsi.productcode === 'SPKTAPBSI'">90 hari sejak
                            tanggal mulai berlakunya asuransi untuk seorang Pihak Yang Diasuransikan, kecuali Pihak Yang
                            Diasuransikan meninggal dunia akibat kecelakaan.</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <ul>
                        <li>
                          <p><b>Kontribusi</b></p>
                          <p>- Kontribusi Tunggal</p>
                          <p>- Tidak ada perbedaan tarif kontribusi untuk Pria & Wanita</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Apa Saja Kewajiban Sebagai Pihak Yang Diasuransikan?</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <ol>
                    <li>Anda harus menjawab semua pertanyaan pada lembar Surat Permohonan Asuransi Jiwa Pembiayaan
                      Kumpulan Syariah (SPAJPK Syariah) dengan lengkap dan benar. Anda bertanggung jawab sepenuhnya atas
                      keakuratan dan kelengkapan data yang Anda berikan kepada Allianz Syariah, karena apabila terdapat
                      kesalahan atau ketidaklengkapan data yang diminta dapat menyebabkan perlindungan asuransi Anda
                      menjadi batal. Allianz Syariah berhak menolak pengajuan Polis Anda, apabila tidak memenuhi
                      persyaratan dan peraturan yang berlaku. </li>
                    <li>Anda harus membaca dan memahami lembar Surat Permohonan Asuransi Jiwa Pembiayaan Kumpulan
                      Syariah (SPAJPK Syariah) dan Ringkasan Informasi Produk dan Layanan (RIPLAY) Personal sebelum
                      menandatanganinya serta Ringkasan Informasi Produk dan Layanan (RIPLAY) Umum. </li>
                  </ol>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Persyaratan dan Tata Cara Pengajuan Asuransi Anda</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p>Dalam hal mengajukan perlindungan asuransi maka Pihak Yang Diasuransikan harus mengisi, melengkapi,
                    dan menandatangani dokumen sebagai berikut:</p>
                  <ol>
                    <li>
                      <p>SPAJPK Syariah atau Surat Permohonan Asuransi Jiwa Pembiayaan Kumpulan Syariah.</p>
                    </li>
                    <li>
                      <p>Bagi Pihak Yang Diasuransikan yang disyaratkan melakukan pemeriksaan kesehatan (medis) sesuai
                        dengan ketentuan underwriting yang berlaku di Allianz Syariah, Pihak Yang Diasuransikan
                        diwajibkan untuk melakukan pemeriksaan kesehatan sesuai dengan ketentuan underwriting yang
                        berlaku di Allianz Syariah.</p>
                    </li>
                    <li>
                      <p>Dokumen-dokumen lainnya yang berkaitan dengan keperluan pengajuan Perlindungan asuransi.</p>
                    </li>
                  </ol>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">Simulasi SmartProtection Mitraguna BSI</p>
                  <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">Simulasi SmartProtection Pensiun Berkah BSI</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p class="mb-2" *ngIf="spajkBsi.productcode==='SPKTAMBSI'">Nasabah A memiliki produk SmartProtection
                    Mitraguna BSI dengan rincian sebagai berikut:</p>
                  <p class="mb-2" *ngIf="spajkBsi.productcode==='SPKTAPBSI'">Nasabah A memiliki produk SmartProtection
                    Pensiun Berkah BSI dengan rincian sebagai berikut:</p>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Nilai Fasilitas Pembiayaan Awal</p>
                          <p class="bottom-note">(Santunan Asuransi Manfaat Meninggal Dunia awal)</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p>: Rp150.000.000,-</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Nilai Biaya Atribusi Awal</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p>: Rp150.000.000,-</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Margin Efektif per Tahun</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">: 11%</p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">: 13%</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Margin Efektif Atribusi per Tahun</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p>: 0%</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Masa Asuransi</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p>: 5 Tahun / 60 bulan</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Tanggal Mulai Perlindungan</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p>: 1 Januari 2024</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Tanggal Akhir Perlindungan</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p>: 1 Januari 2029</p>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-7">
                      <ul>
                        <li>
                          <p>Usia Masuk</p>
                        </li>
                      </ul>
                    </div>
                    <div class="col-5">
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">: 30 Tahun</p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">: 45 Tahun</p>
                    </div>
                  </div>
                  <p>Berdasarkan data di atas, maka:</p>
                  <ol>
                    <li>
                      <p><b>Kontribusi yang dibayarkan:</b></p>
                      <ol type="a">
                        <li>
                          <p><b>Kontribusi untuk manfaat Meninggal Dunia</b></p>
                          <p>Tarif Kontribusi x Nilai Fasilitas Pembiayaan Awal <span
                              *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> 3,52‰ x Rp150.000.000,- = <b>Rp528.000,-</b>
                            </span>
                            <span *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> 24,85‰ x Rp150.000.000,- =
                              <b>Rp3.727.500,-</b>
                            </span>
                          </p>
                        </li>
                        <li>
                          <p><b>Kontribusi untuk manfaat Atribusi</b></p>
                          <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">3.19‰ x Rp15.577.693,-* = Rp49.693,- </p>
                          <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">22.05‰ x Rp19.149.752,-* = Rp422.252,- </p>
                        </li>
                      </ol>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- page 2 -->
        <div class="page-break">
          <!-- content of page 2 -->
          <div class="row page-2-content">
            <div class="col-4 left-section-page-2 mt-3 mb-5">
              <div class="row">
                <div class="col">
                  <ul>
                    <li>
                      <p>Total Kontribusi dengan Atribusi:</p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'">Rp528.000,- + Rp49.693,- = <b>Rp577.693,-</b></p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'">3.727.500,- + Rp422.252,- = <b>Rp4.149.752,-</b></p>
                    </li>
                  </ul>
                  <ol start="2">
                    <li> Dalam hal setelah menjalani 36 bulan Masa Asuransi: <ol type="a">
                        <li>
                          <p><b>Nasabah A Meninggal Dunia</b></p>
                          <p><b>Santunan Asuransi:</b></p>
                          <p><b>- Santunan Asuransi Manfaat Meninggal Dunia:</b></p>
                          <p> (Tarif Tabel Penurunan Santunan Asuransi Manfaat Meninggal Dunia/1000) x Nilai Fasilitas
                            Pembiayaan Awal <span *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> (470.77/1000) x
                              Rp150.000.000,- = <b>Rp70.615.500,-</b>
                            </span>
                            <span *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> (483.78/1000) x Rp150.000.000,- =
                              <b>72.567.000,-</b>
                            </span>
                          </p>
                          <p><b>- Santunan Asuransi Manfaat Atribusi:</b></p>
                          <p> (Tarif Tabel Penurunan Santunan Asuransi Manfaat Atribusi/1000) x Santunan Asuransi
                            Manfaat Atribusi <span *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> (400/1000) x
                              Rp15.577.693,-* = <b>Rp6.231.077,-</b>
                            </span>
                            <span *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> (400/1000) x 19.149.752,-* =
                              <b>Rp7.659.900,-</b>
                            </span>
                          </p>
                          <p>Santunan Asuransi yang dibayarkan:</p>
                          <p class="mb-2" *ngIf="spajkBsi.productcode==='SPKTAMBSI'"><b>Rp70.615.500,- + Rp6.231.077,- =
                              Rp76.846.577,-</b></p>
                          <p class="mb-2" *ngIf="spajkBsi.productcode==='SPKTAPBSI'"><b>Rp72.567.000,- + Rp7.659.900,- =
                              Rp80.226.900,-</b></p>
                        </li>
                      </ol>
                      <ol type="a" start="2">
                        <li>
                          <p>Nasabah A melakukan percepatan pelunasan:</p>
                          <p class="mb-2" *ngIf="spajkBsi.productcode==='SPKTAMBSI'">Kontribusi yang dikembalikan =
                            <b>Rp103.985,-</b></p>
                          <p class="mb-2" *ngIf="spajkBsi.productcode==='SPKTAPBSI'">Kontribusi yang dikembalikan =
                            <b>Rp746.955,-</b></p>
                        </li>
                      </ol>
                      <p class="bottom-note">*nilai ini telah memperhitungkan biaya dan penalti.</p>
                    </li>
                  </ol>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Berakhirnya Perlindungan</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p> Perlindungan berdasarkan Polis dan Sertifikat Asuransi bagi suatu Pihak Yang Diasuransikan akan
                    berakhir dalam hal terjadinya salah satu dari ketentuan-ketentuan berikut: </p>
                  <ol type="a">
                    <li>
                      <p> Pihak Yang Diasuransikan meninggal dunia karena sebab alami dan/atau Penyakit dan/atau
                        Kecelakaan; atau </p>
                    </li>
                    <li>
                      <p> Pihak Yang Diasuransikan telah melunasi Fasilitas Pembiayaan kepada Peserta sebelum Masa
                        Asuransi berakhir; atau </p>
                    </li>
                    <li>
                      <p> Berakhirnya Masa Asuransi sebagaimana tercantum pada Sertifikat Asuransi; atau </p>
                    </li>
                    <li>
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> Pihak Yang Diasuransikan mencapai Usia 70 (tujuh
                        puluh) tahun; atau </p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> Pihak Yang Diasuransikan mencapai Usia 75 (tujuh
                        puluh lima) tahun; atau </p>
                    </li>
                    <li>
                      <p> Pengakhiran atau pembatalan yang dilakukan oleh Peserta ataupun oleh Allianz Syariah selama
                        Masa Berlaku Polis; atau </p>
                    </li>
                    <li>
                      <p> Pada tanggal telah dilakukannya pembayaran Manfaat Asuransi; atau </p>
                    </li>
                    <li>
                      <p> Polis dan/atau Sertifikat Asuransi Diakhiri dengan alasan dan cara lainnya yang diatur dalam
                        Polis ini, </p>
                    </li>
                  </ol>
                  <p>mana yang lebih dahulu terjadi.</p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Persyaratan dan Tata Cara Pengajuan Klaim Anda</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <ol>
                    <li>
                      <p>Prosedur Klaim</p>
                      <div class="row">
                        <div class="col-1">
                          <p>1.1</p>
                        </div>
                        <div class="col-11">
                          <p> Penerima Manfaat harus mengajukan klaim secara tertulis dan memberikan dokumen-dokumen
                            yang disebutkan dalam poin 1.2 di bawah ini kepada Allianz Syariah, tidak lebih dari <b>180
                              (seratus delapan puluh) hari kalender</b> sejak dari tanggal Pihak Yang Diasuransikan
                            meninggal dunia. </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <p>1.2</p>
                        </div>
                        <div class="col-11">
                          <p> Dokumen-dokumen yang diperlukan untuk pengajuan klaim oleh Penerima Manfaat adalah sebagai
                            berikut : </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                        </div>
                        <div class="col-11">
                          <ol type="a">
                            <li>
                              <p> Formulir klaim meninggal dunia yang disediakan oleh Allianz Syariah dan yang harus
                                diisi dengan lengkap dan benar. </p>
                            </li>
                            <li>
                              <p>Salinan Kartu Tanda Penduduk Pihak Yang Diasuransikan.</p>
                            </li>
                            <li>
                              <p>Salinan Kartu Keluarga Pihak Yang Diasuransikan.</p>
                            </li>
                            <li>
                              <p>Salinan Kartu Tanda Penduduk ahli waris.</p>
                            </li>
                            <li>
                              <p>Surat Keterangan Meninggal dari Rumah Sakit dan keterangan sebab meninggal dunia dari
                                dokter yang merawat.</p>
                            </li>
                            <li>
                              <p>Surat Kematian dari Kelurahan.</p>
                            </li>
                            <li>
                              <p> Surat Keterangan dari Kepolisian dalam hal meninggal dunia tidak wajar atau karena
                                kecelakaan lalu lintas. </p>
                            </li>
                            <li>
                              <p> Surat keterangan dari Kantor Perwakilan Republik Indonesia setempat dalam hal
                                meninggal dunia di luar negeri; dan </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="col-4 middle-section-page-2 mt-3 mb-5">
              <div class="row">
                <div class="col">
                  <ul>
                    <li>
                      <div class="row">
                        <div class="col-1">
                        </div>
                        <div class="col-11">
                          <ol type="a" start="9">
                            <li>
                              <p> Dokumen-dokumen yang disebutkan dalam butir (e), (f), (g), (h) di atas bisa diberikan
                                dalam bentuk fotokopi (bukan asli) dengan syarat bahwa dokumen tersebut harus
                                dilegalisir oleh pihak yang berwenang mengeluarkan dokumen tersebut. </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <p>1.3</p>
                        </div>
                        <div class="col-11">
                          <p>Allianz Syariah berhak untuk mendapatkan/meminta dokumen lainnya dari rumah sakit dan/atau
                            pihak lain, jika dianggap dokumen belum cukup untuk dapat memproses penyelesaian klaim.</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <p>1.4</p>
                        </div>
                        <div class="col-11">
                          <p>Pembayaran klaim atas Manfaat Asuransi akan dilakukan oleh Allianz Syariah
                            selambat-lambatnya dalam waktu 5 (lima) hari kerja sejak</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                        </div>
                        <div class="col-11">
                          <p>formulir klaim dan dokumen pendukung telah secara lengkap dan benar diterima oleh Allianz
                            Syariah dan klaim disetujui oleh Allianz Syariah.</p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <p>1.5</p>
                        </div>
                        <div class="col-11">
                          <p><b>Allianz Syariah akan menolak klaim atau membatalkan Polis dan/atau Sertifikat Asuransi
                              jika Peserta, Pihak Yang Diasuransikan atau Penerima Manfaat</b> (yang mana yang sesuai)
                            <b>tidak memberikan informasi sesuai kebutuhan Allianz Syariah atau memberikan Allianz
                              Syariah informasi yang tidak benar ketika informasi tersebut:</b></p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1"></div>
                        <div class="col-11">
                          <ol type="a">
                            <li>
                              <p><b>Merupakan informasi fakta yang penting yang telah Allianz Syariah pertanyakan dalam
                                  formulir klaim dan yang Allianz Syariah percaya akan berpengaruh pada keputusan
                                  Allianz Syariah apakah akan menerima aplikasi klaim dari Peserta, Pihak Yang
                                  Diasuransikan atau Penerima Manfaat </b>(yang mana yang sesuai)<b>, atau</b></p>
                            </li>
                            <li>
                              <p><b>Merupakan fakta yang diketahui oleh Peserta, Pihak Yang Diasuransikan atau Penerima
                                  Manfaat </b>(yang mana yang sesuai)<b>, atau</b></p>
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1"></div>
                        <div class="col-11">
                          <ol start="3" type="a">
                            <li>
                              <p><b>Merupakan fakta yang Allianz Syariah harap dapat diungkapkan oleh Peserta, Pihak
                                  Yang Diasuransikan atau Penerima Manfaat </b>(yang mana yang sesuai). </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <p>1.6</p>
                        </div>
                        <div class="col-11">
                          <p> Allianz Syariah akan menolak jika klaim yang dibuat oleh Peserta atau Penerima Manfaat
                            adalah penipuan, atau jika ada pernyataan atau informasi palsu yang dibuat atau digunakan
                            untuk mendukung penipuan atau jika ada cara-cara penipuan oleh Peserta atau Penerima Manfaat
                            untuk memperoleh manfaat berdasarkan Polis ini. Dalam hal tersebut, semua Manfaat Asuransi
                            atau yang seharusnya dibayarkan akan menjadi batal, dan Allianz Syariah juga memiliki hak
                            untuk melakukan salah satu atau semua hal berikut: </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1"></div>
                        <div class="col-11">
                          <ol type="a">
                            <li>
                              <p>Mengakhiri Polis dengan segera; dan/atau</p>
                            </li>
                            <li>
                              <p>Memberlakukan syarat dan ketentuan tambahan sebagaimana Allianz Syariah anggap perlu;
                                dan/atau</p>
                            </li>
                            <li>
                              <p>Mengambil tindakan hukum yang Allianz Syariah anggap perlu.</p>
                            </li>
                          </ol>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-1">
                          <p>1.7</p>
                        </div>
                        <div class="col-11">
                          <p> Pengajuan permohonan klaim untuk pembayaran Manfaat Asuransi adalah sah apabila
                            syarat-syarat atas prosedur dan persyaratan dokumen klaim telah dipenuhi seluruhnya, dan
                            Allianz Syariah mempunyai hak untuk menolak permohonan klaim atas pembayaran Manfaat
                            Asuransi yang diajukan dan/atau menolak untuk membayar Manfaat Asuransi apabila
                            syarat-syarat tersebut tidak dipenuhi. </p>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ol start="2">
                    <li>
                      <p> Dalam hal jumlah Manfaat Asuransi yang diterima oleh Penerima Manfaat dari Allianz Syariah
                        lebih besar dari sisa pembiayaan Pihak Yang Diasuransikan berdasarkan Fasilitas Pembiayaan pada
                        saat Pihak Yang Diasuransikan meninggal dunia <b>(“Selisih Lebih Manfaat Asuransi”)</b>, maka
                        Penerima Manfaat berkewajiban untuk membayarkan Selisih Lebih Manfaat Asuransi tersebut kepada
                        ahli waris</p>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="col-4 right-section-page-2 mt-3 mb-5">
              <div class="row">
                <div class="col">
                  <ul style="list-style-type: none;">
                    <li>
                      <p>Pihak Yang Diasuransikan yang sah sesuai dengan peraturan perundang- undangan yang berlaku.
                        Allianz Syariah tidak bertanggung jawab atas pembayaran atau ketiadaan pembayaran Selisih Lebih
                        Manfaat Asuransi tersebut oleh Penerima Manfaat kepada ahli waris Pihak Yang Diasuransikan yang
                        sah tersebut. </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Pengecualian</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p><b>Allianz Syariah tidak berkewajiban untuk membayar Manfaat Asuransi jika Pihak Yang
                      Diasuransikan meninggal dunia disebabkan oleh, secara langsung maupun tidak langsung, salah satu
                      kejadian-kejadian di bawah ini:</b></p>
                  <ol>
                    <li>
                      <p><b>Pihak Yang Diasuransikan meninggal dunia karena bunuh diri; atau</b></p>
                    </li>
                    <li>
                      <p><b>Pihak Yang Diasuransikan meninggal dalam Masa Asuransi karena dihukum mati oleh pengadilan,
                          atau karena dengan sengaja melakukan atau turut serta dalam suatu tindak kejahatan atau suatu
                          percobaan tindak kejahatan, baik aktif maupun tidak; atau</b></p>
                    </li>
                    <li>
                      <p><b>Terlibat dalam perkelahian, kecuali apabila Pihak Yang Diasuransikan adalah pihak yang
                          mempertahankan diri; atau</b></p>
                    </li>
                    <li>
                      <p><b>Kecelakaan segala bentuk penerbangan non komersial (bukan anggota IATA) dimana Pihak Yang
                          Diasuransikan pada saat itu bertindak selaku Pilot dan tidak membayar kontribusi tambahan
                          aviasi sesuai ketentuan; atau</b></p>
                    </li>
                    <li>
                      <p><b>Terlibat dalam perang atau kegiatan sejenis perang, baik yang dinyatakan ataupun tidak,
                          invasi, pemberontakan, tindakan terorisme, kerusuhan, kerusuhan sipil, atau berdinas dalam
                          angkatan bersenjata dan kepolisian suatu negara atau badan internasional; atau</b></p>
                    </li>
                    <li>
                      <p><b>Berada di bawah pengaruh alkohol, obat bius dan narkotika; atau</b></p>
                    </li>
                    <li>
                      <p><b>Dalam jangka waktu 24 (dua puluh empat) bulan pertama sejak tanggal berlakunya Masa
                          Asuransi, Pihak Yang Diasuransikan meninggal karena Kondisi yang Telah Ada Sebelumnya
                          <i>(Pre-Existing Condition)</i> baik yang diungkapkan dalam SPAJPK Syariah atau tidak, kecuali
                          dalam hal Kondisi yang Telah Ada Sebelumnya tersebut merupakan Kondisi atau Penyakit yang
                          Disetujui oleh Allianz Syariah; atau </b></p>
                    </li>
                    <li>
                      <p><b>Segala penyakit yang disebabkan baik langsung maupun tidak langsung oleh AIDS (Acquired
                          Immune Deficiency Syndrome) atau penyakit yang berhubungan dengan AIDS (AIDS Related
                          Complex/ARC); atau</b>
                      </p>
                    </li>
                    <li>
                      <p><b>Pihak Yang Diasuransikan meninggal akibat tindak kejahatan asuransi yang dilakukan oleh
                          pihak yang memiliki atau turut memiliki kepentingan dalam perlindungan asuransi ini; atau</b>
                      </p>
                    </li>
                    <li>
                      <p><b>Reaksi nuklir, radiasi, atau terkontaminasi zat radioaktif.</b></p>
                    </li>
                  </ol>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Tata Cara Pengaduan Dan Penyelesaian Sengketa</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <ol>
                    <li>
                      <p>Layanan Pengaduan</p>
                      <ol type="a">
                        <li>
                          <p>Peserta dapat menyampaikan pengaduan secara tertulis atau lisan kepada Kami melalui jalur
                            layanan pengaduan yang disediakan oleh Kami.</p>
                        </li>
                        <li>
                          <p> Kami akan menindaklanjuti pengaduan tersebut dalam jangka waktu sebagai berikut: </p>
                          <ol type="i">
                            <li>
                              <p> Untuk pengaduan secara lisan: 5 (lima) hari kerja sejak pengaduan diterima oleh Kami
                                (atau jangka waktu lainnya yang dari waktu ke waktu diatur dalam peraturan yang
                                ditetapkan oleh Otoritas Jasa Keuangan (”OJK”)). </p>
                            </li>
                            <li>
                              <p> Untuk pengaduan secara tertulis: 10 (sepuluh) hari kerja sejak dokumen pendukung
                                diterima secara lengkap oleh Kami (atau jangka waktu lainnya yang dari waktu ke waktu
                                diatur dalam peraturan yang ditetapkan oleh OJK). </p>
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <br>
        </div>
        <!-- page 3 -->
        <div class="page-break">
          <!-- content -->
          <div class="row page-3-content">
            <div class="col-4 left-section-page-3 mt-1 mb-1">
              <div class="row">
                <div class="col">
                  <ul style="list-style-type: none;">
                    <li>
                      <ol type="a" start="3">
                        <li>
                          <p> Jika terdapat kondisi tertentu sebagaimana yang diatur dalam peraturan yang ditetapkan
                            oleh OJK, dan dengan melakukan pemberitahuan sebelumnya kepada Peserta, Kami dapat (i)
                            memperpanjang jangka waktu yang disebutkan dalam poin (1.b); atau (ii) menindaklanjuti
                            pengaduan tersebut di luar jangka waktu yang disebutkan dalam poin (1.b). </p>
                        </li>
                        <li>
                          <p> Informasi lebih lanjut mengenai jalur layanan pengaduan dan prosedur pengaduan tersedia
                            untuk Peserta di situs resmi Kami. </p>
                        </li>
                        <li>
                          <p> Dalam hal tidak terdapat kesepakatan terhadap hasil tindak lanjut pengaduan sebagaimana
                            disebutkan dalam poin (1), Peserta dapat menyampaikan pengaduan kepada OJK untuk penanganan
                            pengaduan sesuai dengan kewenangan OJK atau menyelesaikan sengketa terkait pengaduan
                            tersebut sesuai dengan ketentuan poin (2). </p>
                        </li>
                      </ol>
                    </li>
                  </ul>
                  <ol start="2">
                    <li>
                      <p> Penyelesaian Sengketa </p>
                      <ol type="a">
                        <li>
                          <p>Apabila timbul sengketa antara Peserta dan Kami atau pihak lain yang berkepentingan dengan
                            Polis, maka sengketa dapat terlebih dahulu diselesaikan melalui musyawarah untuk mufakat.
                          </p>
                        </li>
                        <li>
                          <p> Dalam hal sengketa sebagaimana disebutkan dalam poin (2.a) tidak dapat diselesaikan dan
                            tidak mencapai kesepakatan, Kami dan Peserta dapat menyelesaikan sengketa di luar pengadilan
                            atau melalui pengadilan agama yang berwenang. </p>
                        </li>
                        <li>
                          <p> Penyelesaian sengketa di luar pengadilan sebagaimana yang dimaksud pada poin (2.b),
                            dilakukan melalui Lembaga Alternatif Penyelesaian Sengketa yang ditetapkan oleh Otoritas
                            Jasa Keuangan (OJK), antara lain Lembaga Alternatif Penyelesaian Sengketa Sektor Jasa
                            Keuangan atau Lembaga Alternatif Penyelesaian Sengketa lainnya yang berwenang dan ditetapkan
                            oleh OJK dari waktu ke waktu. </p>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Pengiriman Dokumen Klaim</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p><b>Allianz Document Management Center (ADMC)</b></p>
                  <p>Setiabudi Atrium, Lt. 3 Suite 308 A-309</p>
                  <p>Jl. H.R. Rasuna Said Kav. 62 Kuningan,</p>
                  <p>Karet Kuningan Kec.</p>
                  <p class="mb-2">Setiabudi Jakarta Selatan 12920</p>
                  <p class="mb-2">Penerimaan dokumen pada hari Senin – Jumat, Jam 08.00 – 17.00 waktu setempat (kecuali
                    hari libur) </p>
                  <p class="mb-3"> Untuk pengiriman seluruh dokumen klaim ke Allianz Syariah dapat dilakukan menggunakan
                    jasa pengiriman PT POS Indonesia tanpa biaya kirim. </p>
                </div>
              </div>
              <div class="row title-card">
                <div class="col">
                  <p>Pelayanan, Penyelesaian Pengaduan dan Klaim</p>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <p class="mb-2"> Apabila ada pertanyaan dan keluhan terkait produk dan/atau layanan Allianz Syariah,
                    silakan menyampaikan pertanyaan dan keluhan melalui Customer Center Allianz Syariah: </p>
                  <p><b>Alamat:</b></p>
                  <p><b>PT Asuransi Allianz Life Syariah Indonesia Customer Lounge</b></p>
                  <p>World Trade Centre 6, Ground Floor</p>
                  <p>Jl. Jenderal Sudirman Kav. 29-31</p>
                  <p class="mb-3">Jakarta Selatan 12920, Indonesia</p>
                  <p><b>Corporate Number:</b></p>
                  <p class="mb-3">+6221 2926 8888</p>
                  <p><b>AllianzCare Syariah:</b></p>
                  <p class="mb-3">1500 139</p>
                  <p><b>Email:</b></p>
                  <p class="mb-3"><a href="mailto:Allianzcaresyariah@allianz.co.id">Allianzcaresyariah@allianz.co.id</a>
                  </p>
                  <p><b>Website:</b></p>
                  <p class="mb-3"><a href="www.allianz.co.id">www.allianz.co.id</a></p>
                </div>
              </div>
            </div>
            <div class="col-8 right-section-page-3 mt-1 mb-1">
              <div class="row" style="margin-bottom: 21em;">
                <div class="col">
                  <p class="mb-3"><b>Catatan Penting</b></p>
                  <ul class="mb-3">
                    <li>
                      <p> PT Asuransi Allianz Life Syariah Indonesia berizin dan diawasi oleh Otoritas Jasa Keuangan,
                        dan Tenaga Pemasarnya telah memegang lisensi dari Asosiasi Asuransi Syariah Indonesia. </p>
                    </li>
                    <li>
                      <p *ngIf="spajkBsi.productcode==='SPKTAMBSI'"> SmartProtection Mitraguna BSI adalah produk
                        asuransi yang diterbitkan oleh PT Asuransi Allianz Life Syariah Indonesia. PT Bank Syariah
                        Indonesia, Tbk ("Bank") hanya bertindak sebagai pemberi referensi SmartProtection Mitraguna BSI.
                        SmartProtection Mitraguna BSI bukan produk Bank sehingga Bank tidak bertanggung jawab atas
                        setiap dan semua klaim dan segala risiko apapun atas Polis yang diterbitkan oleh PT Asuransi
                        Allianz Life Syariah Indonesia. SmartProtection Mitraguna BSI tidak dijamin oleh Bank dan
                        afiliasi-afiliasinya dan tidak termasuk dalam cakupan objek program penjaminan Pemerintah
                        Republik Indonesia atau Lembaga Penjamin Simpanan (“LPS”). </p>
                      <p *ngIf="spajkBsi.productcode==='SPKTAPBSI'"> SmartProtection Pensiun Berkah BSI adalah produk
                        asuransi yang diterbitkan oleh PT Asuransi Allianz Life Syariah Indonesia. PT Bank Syariah
                        Indonesia, Tbk ("Bank") hanya bertindak sebagai pemberi referensi SmartProtection Pensiun Berkah
                        BSI. SmartProtection Pensiun Berkah BSI bukan produk Bank sehingga Bank tidak bertanggung jawab
                        atas setiap dan semua klaim dan segala risiko apapun atas Polis yang diterbitkan oleh PT
                        Asuransi Allianz Life Syariah Indonesia. SmartProtection Pensiun Berkah BSI tidak dijamin oleh
                        Bank dan afiliasi-afiliasinya dan tidak termasuk dalam cakupan objek program penjaminan
                        Pemerintah Republik Indonesia atau Lembaga Penjamin Simpanan (“LPS”). </p>
                    </li>
                    <li>
                      <p>Penjelasan perlindungan asuransi yang lengkap terdapat pada Polis. Perlindungan asuransi
                        berlaku ketentuan Pengecualian yang terdapat pada Polis dan/atau Sertifikat Asuransi, yaitu
                        hal-hal yang tidak ditanggung dalam Polis.</p>
                    </li>
                    <li>
                      <p>Kontribusi yang dibayarkan sudah termasuk komisi untuk pihak Bank.</p>
                    </li>
                    <li>
                      <p>Kami akan menginformasikan kepada Anda apabila terjadi perubahan manfaat, biaya, risiko,
                        syarat, dan ketentuan sebagaimana tercantum di dalam Polis paling lambat 30 (tiga puluh) hari
                        kerja sebelum berlakunya perubahan manfaat, biaya, risiko, syarat, dan ketentuan tersebut.</p>
                    </li>
                    <li>
                      <p>Anda wajib membaca dengan teliti RIPLAY Personal ini sebelum menyetujui pengajuan produk dan
                        berhak bertanya kepada Tenaga Pemasar atas semua hal terkait RIPLAY Personal.</p>
                    </li>
                    <li>
                      <p>RIPLAY Personal ini bukan merupakan kontrak atau perjanjian asuransi antara PT Asuransi Allianz
                        Life Syariah Indonesia dengan Peserta sehingga tidak mengikat PT Asuransi Allianz Life Syariah
                        Indonesia/Peserta.</p>
                    </li>
                    <li>
                      <p>Anda wajib membaca, memahami dan menandatangani aplikasi dan dokumen-dokumen pendukung
                        pengajuan asuransi.</p>
                    </li>
                    <li>
                      <p>Anda telah membaca, menerima penjelasan atas pertanyaan Anda (jika ada) dan memahami produk
                        asuransi ini sesuai RIPLAY Personal.</p>
                    </li>
                    <li>
                      <p>Informasi yang tercantum dalam RIPLAY Personal ini berlaku sejak tanggal cetak dokumen sampai
                        dengan 30 (tiga puluh) hari kalender dari tanggal cetak dokumen.</p>
                    </li>
                    <li>
                      <p> RIPLAY Personal ini dapat ditandatangani dengan tanda tangan elektronik (baik seluruhnya atau
                        sebagian), yang harus dianggap sebagai tanda tangan asli untuk semua tujuan dan yang memiliki
                        kekuatan hukum yang sama dengan tanda tangan asli (basah). Anda mengakui dan menyetujui bahwa
                        Anda secara tegas mengesampingkan setiap hak untuk (i) mengajukan pembelaan atau pelepasan
                        tanggung jawab/kewajiban; dan/atau (ii) membatalkan RIPLAY Personal ini, atas alasan
                        penandatanganan RIPLAY Personal ini oleh Anda dengan tanda tangan elektronik. </p>
                    </li>
                    <li>
                      <p> RIPLAY Personal ini bukan merupakan dari aplikasi pengajuan asuransi dan Polis dan/atau
                        Sertifikat Asuransi. </p>
                    </li>
                    <li>
                      <p> Kami berhak menolak pengajuan Polis Anda, apabila tidak memenuhi persyaratan dan peraturan
                        yang berlaku. </p>
                    </li>
                  </ul>
                  <p class="small-note">Definisi</p>
                  <ul *ngIf="spajkBsi.productcode==='SPKTAPBSI'">
                    <li>
                      <p class="small-note"><b>Anda</b> adalah Pihak Yang Diasuransikan.</p>
                    </li>
                    <li>
                      <p class="small-note"><b>Kami</b> atau <b>Allianz Syariah</b> adalah PT Asuransi Allianz Life
                        Syariah Indonesia </p>
                    </li>
                    <li>
                      <p class="small-note"><b>Cooling-Off Period</b> adalah waktu yang diberikan oleh Allianz Syariah
                        kepada Peserta dan/atau setiap Pihak Yang Diasuransikan untuk mempelajari Polis atau Sertifikat
                        Asuransi (yang mana yang sesuai), yaitu <b>14 (empat belas) hari kalender</b> terhitung sejak
                        tanggal diterimanya Polis oleh Peserta atau Sertifikat Asuransi oleh Pihak Yang
                        Diasuransikan (yang mana yang sesuai).</p>
                    </li>
                  </ul>
                  <ul *ngIf="spajkBsi.productcode==='SPKTAMBSI'">
                    <li>
                      <p class="small-note"><b>Anda</b> adalah Pihak Yang Diasuransikan.</p>
                    </li>
                    <li>
                      <p class="small-note"><b>Kami</b> atau <b>Allianz Syariah</b> adalah PT Asuransi Allianz Life
                        Syariah Indonesia </p>
                    </li>
                    <li>
                      <p class="small-note"><b>Manfaat Asuransi</b> adalah Manfaat yang menjadi hak Anda berdasarkan
                        ketentuan Polis dan tertera pada Tabel Manfaat.</p>
                    </li>
                    <li>
                      <p class="small-note"><b>Cooling-Off Period</b> adalah waktu yang diberikan oleh Allianz Syariah
                        kepada Peserta dan/atau setiap Pihak Yang Diasuransikan untuk mempelajari Polis atau Sertifikat
                        Asuransi (yang mana yang sesuai), yaitu <b>14 (empat belas) hari kalender</b> terhitung sejak
                        tanggal diterimanya Polis oleh Peserta atau Sertifikat Asuransi oleh Pihak Yang
                        Diasuransikan (yang mana yang sesuai).</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3">
                  <p>Tempat/Ditandatangani di</p>
                </div>
                <div class="col-9">
                  <p>: <span class="field-underline">____________________________________________________</span></p>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3">
                  <p>Tanggal</p>
                </div>
                <div class="col-9">
                  <p>: <span class="field-underline">{{this.todayDate | date:"dd - MM - YYYY" }}</span></p>
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  <p class="m-1">Tanda Tangan Staf Bank Pemberi Referensi</p>
                </div>
                <div class="col-5">
                  <p class="m-1">Tanda Tangan Anda</p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5">
                  <br><br><br><br><br><br>
                  <p>{{this.dataSpajk.salesName}}</p>
                  <p class="mb-3">(Tanda Tangan dan Nama Jelas)</p>
                </div>
                <div class="col-5">
                  <br><br><br><br><br><br>
                  <p>({{spajkBsi.namaLengkap}})</p>
                  <p class="mb-3">(Tanda Tangan dan Nama Jelas)</p>
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                </div>
                <div class="col-5">
                  <p class="small-note">Saya telah menerima, membaca, serta memahami dan menyetujui semua informasi di
                    Ilustrasi dan RIPLAY Personal ini. Saya juga telah menerima penjelasan atas pertanyaan saya (jika
                    ada) dari Tenaga Pemasar asuransi.</p>
                </div>
              </div>
            </div>
          </div>
          <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column justify-content-center flex-gap">
    <div class="d-flex flex-row flex-gap">
      <button class="btn btn-back mt-3 py-3 flex-grow-1" type="button" (click)="downloadSpajk()">
        <span *ngIf="this.isLoadingSpajk" class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true"></span>
        Unduh SPAJPK Syariah</button>
      <button class="btn btn-back mt-3 py-3 flex-grow-1" type="button" (click)="downloadRiplay()">
        <span *ngIf="this.isLoadingRiplay" class="spinner-border spinner-border-sm" role="status"
              aria-hidden="true"></span>
        Unduh RIPLAY Personal
      </button>
    </div>
    <!--    <button class="btn btn-back mt-3 py-3 flex-grow-1" type="button">SIMPAN</button>-->
    <button class="btn btn-continue mt-3 py-3 flex-grow-1" type="button" (click)="continue()"
      [disabled]="this.isLoadingLanjut">
      <span *ngIf="this.isLoadingLanjut" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      LANJUT </button>
  </div>
</div>
